/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 1835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: function() { return /* binding */ euiButtonStyles; }
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6684);

const euiButtonStyles = (0,lit__WEBPACK_IMPORTED_MODULE_0__/* .css */ .AH) `
    .eui-btn {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        min-width: 134px;
        padding: var(--eui-button-padding);
        font-family: inherit;
        font-size: 14px;
        font-weight: var(--eui-button-text-font-weight);
        border: solid 1px transparent;
        border-radius: var(--eui-button-border-radius);
        transition: all ease-in-out 0.1s;
        text-align: center;
        text-decoration: none;
        user-select: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        appearance: none;
        -webkit-appearance: none;
    }
    .eui-btn:hover {
        cursor: pointer;
        text-decoration: none;
    }
    .eui-btn:focus {
        outline: none;
    }
    .eui-btn:disabled {
        cursor: default;
        opacity: 0.3;
    }
    .eui-btn--primary {
        color: var(--eui-color-primary);
    }
    .eui-btn--primary:not(.eui-btn--text) {
        color: var(--eui-color-grey-0);
        background-color: var(--eui-color-primary);
    }
    .eui-btn--primary:not(.eui-btn--text):hover {
        border-color: var(--eui-color-primary);
    }
    .eui-btn--primary:not(.eui-btn--text):active {
        background-color: var(--eui-color-primary);
        border-color: var(--eui-color-primary);
    }
    .eui-btn--primary:not(.eui-btn--text):focus {
        background-color: var(--eui-color-primary);
        border-color: var(--eui-color-primary);
    }
    .eui-btn--primary:not(.eui-btn--text):disabled {
        border-color: transparent;
    }
    .eui-btn--secondary {
        color: var(--eui-color-grey-800);
        background-color: var(--eui-color-grey-0);
        border-color: var(--eui-color-grey-300);
    }
    .eui-btn--secondary:hover {
        background-color: var(--eui-color-grey-50);
    }
    .eui-btn--secondary:active {
        background-color: var(--eui-color-grey-100);
    }
    .eui-btn--secondary:focus {
        background-color: var(--eui-color-grey-100);
    }
    .eui-btn--secondary:disabled {
        border-color: transparent;
    }
    .eui-btn--outline {
        border-color: var(--eui-color-primary);
        color: var(--eui-color-primary);
        background-color: unset;
    }
    .eui-btn--outline:not(.eui-btn--text):hover {
        background-color: var(--eui-color-primary);
        color: var(--eui-color-grey-0);
    }
    .eui-btn--outline:not(.eui-btn--text):active {
        background-color: var(--eui-color-primary);
        border-color: var(--eui-color-primary);
        color: var(--eui-color-grey-0);
    }
    .eui-btn--outline:not(.eui-btn--text):focus {
        background-color: var(--eui-color-primary);
        border-color: var(--eui-color-primary);
        color: var(--eui-color-grey-0);
    }
    .eui-btn--outline:not(.eui-btn--text):disabled {
        background-color: unset;
        color: var(--eui-color-primary);
    }
    .eui-btn--light {
        color: var(--eui-color-grey-secondary-600);
        background-color: var(--eui-color-grey-100);
        font-weight: 600;
    }
    .eui-btn--light:hover {
        border-color: #eaeaea;
    }
    .eui-btn--light:active {
        border-color: #eaeaea;
        background-color: #eaeaeb;
    }
    .eui-btn--light:focus {
        border-color: #eaeaea;
        background-color: #eaeaeb;
    }
    .eui-btn--light:disabled {
        border-color: transparent;
    }
    .eui-btn--danger {
        color: var(--eui-color-error);
        background-color: var(--eui-color-grey-100);
        font-weight: 600;
    }
    .eui-btn--danger:hover {
        border-color: #fcd3d3;
    }
    .eui-btn--danger:active {
        border-color: #fcd3d3;
        background-color: #fcd3d3;
    }
    .eui-btn--danger:focus {
        border-color: #fcd3d3;
        background-color: #fcd3d3;
    }
    .eui-btn--danger:disabled {
        border-color: transparent;
    }
    .eui-btn--text {
        min-width: unset;
        font-size: 14px;
        font-weight: var(--eui-button-text-font-weight);
        padding: 10px;
        text-decoration: var(--eui-button-text-decoration);
    }
    .eui-btn--text,
    .eui-btn--text:hover,
    .eui-btn--text:focus,
    .eui-btn--text:active,
    .eui-btn--text:disabled {
        border: none;
        background-color: unset;
    }
    .eui-btn--text:hover {
        opacity: 0.7;
    }
    .eui-btn--text:focus,
    .eui-btn--text:active {
        opacity: 0.5;
    }
    .eui-btn--text:disabled {
        opacity: 0.4;
    }
    .eui-btn--big {
        font-size: 16px;
    }
    .eui-btn--small {
        font-size: 10px;
        padding: 6px 25px;
        min-width: 108px;
    }
    .eui-btn--md {
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        padding: var(--eui-button-padding-md);
    }
    .eui-btn--levitate {
        box-shadow: 0px 3px 15px rgba(6, 167, 226, 0.2);
    }
    .eui-btn--levitate:hover {
        transform: translateY(-4px);
        box-shadow: 0px 10px 15px rgba(6, 167, 226, 0.25);
    }
    .eui-btn--levitate:active {
        transform: translateY(-4px);
        box-shadow: 0px 10px 15px rgba(6, 167, 226, 0.25);
    }
    .eui-btn--levitate:focus {
        transform: translateY(-4px);
        box-shadow: 0px 10px 15px rgba(6, 167, 226, 0.25);
    }
    .eui-btn--levitate:disabled {
        transform: none;
    }
    .eui-btn--scale {
        box-shadow: 0px 3px 15px rgba(6, 167, 226, 0.2);
    }
    .eui-btn--scale:hover {
        transform: scale(1.03);
        box-shadow: 0px 10px 15px rgba(6, 167, 226, 0.25);
    }
    .eui-btn--scale:active {
        transform: scale(1);
        box-shadow: 0px 10px 15px rgba(6, 167, 226, 0.25);
    }
    .eui-btn--scale:disabled {
        transform: none;
    }
    .eui-btn--block {
        margin: 10px auto;
        display: block;
    }
    .eui-btn--full-width {
        width: 100%;
    }
  }`;


/***/ }),

/***/ 9084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ euiColorStyles; }
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6684);

const euiColorStyles = (0,lit__WEBPACK_IMPORTED_MODULE_0__/* .css */ .AH) `
    .eui-color-primary {
        color: var(--eui-color-primary)
    }
    
    .eui-color-primary-900 {
        color: var(--eui-color-primary-900)
    }
    
    .eui-color-primary-800 {
        color: var(--eui-color-primary-800)
    }
    
    .eui-color-primary-700 {
        color: var(--eui-color-primary-700)
    }
    
    .eui-color-primary-600 {
        color: var(--eui-color-primary-600)
    }
    
    .eui-color-primary-500 {
        color: var(--eui-color-primary)
    }
    
    .eui-color-primary-400 {
        color: var(--eui-color-primary-400)
    }
    
    .eui-color-primary-300 {
        color: var(--eui-color-primary-300)
    }
    
    .eui-color-primary-200 {
        color: var(--eui-color-primary-200)
    }
    
    .eui-color-primary-100 {
        color: var(--eui-color-primary-100)
    }
    
    .eui-color-primary-50 {
        color: var(--eui-color-primary-50)
    }
    
    .eui-color-primary-0 {
        color: var(--eui-color-primary-0)
    }
    
    .eui-color-secondary {
        color: var(--eui-color-secondary)
    }
    
    .eui-color-secondary-900 {
        color: var(--eui-color-secondary-900)
    }
    
    .eui-color-secondary-800 {
        color: var(--eui-color-secondary-800)
    }
    
    .eui-color-secondary-700 {
        color: var(--eui-color-secondary-700)
    }
    
    .eui-color-secondary-600 {
        color: var(--eui-color-secondary-600)
    }
    
    .eui-color-secondary-500 {
        color: var(--eui-color-secondary)
    }
    
    .eui-color-secondary-400 {
        color: var(--eui-color-secondary-400)
    }
    
    .eui-color-secondary-300 {
        color: var(--eui-color-secondary-300)
    }
    
    .eui-color-secondary-200 {
        color: var(--eui-color-secondary-200)
    }
    
    .eui-color-secondary-100 {
        color: var(--eui-color-secondary-100)
    }
    
    .eui-color-secondary-50 {
        color: var(--eui-color-secondary-50)
    }
    
    .eui-color-secondary-0 {
        color: var(--eui-color-secondary-0)
    }
    
    .eui-color-grey-900 {
        color: var(--eui-color-grey-900)
    }
    
    .eui-color-grey-800 {
        color: var(--eui-color-grey-800)
    }
    
    .eui-color-grey-700 {
        color: var(--eui-color-grey-700)
    }
    
    .eui-color-grey-600 {
        color: var(--eui-color-grey-600)
    }
    
    .eui-color-grey-500 {
        color: var(--eui-color-grey-500)
    }
    
    .eui-color-grey-400 {
        color: var(--eui-color-grey-400)
    }
    
    .eui-color-grey-300 {
        color: var(--eui-color-grey-300)
    }
    
    .eui-color-grey-200 {
        color: var(--eui-color-grey-200)
    }
    
    .eui-color-grey-100 {
        color: var(--eui-color-grey-100)
    }
    
    .eui-color-grey-50 {
        color: var(--eui-color-grey-50)
    }
    
    .eui-color-grey-0 {
        color: var(--eui-color-grey-0)
    }
    
    .eui-color-grey-secondary-900 {
        color: var(--eui-color-grey-secondary-900)
    }
    
    .eui-color-grey-secondary-800 {
        color: var(--eui-color-grey-secondary-800)
    }
    
    .eui-color-grey-secondary-700 {
        color: var(--eui-color-grey-secondary-700)
    }
    
    .eui-color-grey-secondary-600 {
        color: var(--eui-color-grey-secondary-600)
    }
    
    .eui-color-grey-secondary-500 {
        color: var(--eui-color-grey-secondary-500)
    }
    
    .eui-color-grey-secondary-400 {
        color: var(--eui-color-grey-secondary-400)
    }
    
    .eui-color-grey-secondary-300 {
        color: var(--eui-color-grey-secondary-300)
    }
    
    .eui-color-grey-secondary-200 {
        color: var(--eui-color-grey-secondary-200)
    }
    
    .eui-color-grey-secondary-100 {
        color: var(--eui-color-grey-secondary-100)
    }
    
    .eui-color-grey-secondary-50 {
        color: var(--eui-color-grey-secondary-50)
    }
    
    .eui-color-grey-secondary-0 {
        color: var(--eui-color-grey-secondary-0)
    }
    
    .eui-color-error {
        color: var(--eui-color-error)
    }
    
    .eui-color-success {
        color: var(--eui-color-success)
    }
    
    .eui-color-warning {
        color: var(--eui-color-warning)
    }
    
    .eui-color-white {
        color: var(--eui-color-grey-0)
    }

    .eui-color-cookies-title {
        color: var(--eui-color-cookies-title);
    }

    .eui-color-cookies-button {
        background-color: var(--eui-color-cookies-button);
    }

    .eui-color-cookies-button-configure {
        color: var(--eui-color-cookies-button);
    }
  `;


/***/ }),

/***/ 1754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ euiTextStyles; }
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6684);

const euiTextStyles = (0,lit__WEBPACK_IMPORTED_MODULE_0__/* .css */ .AH) `
  .eui-text-type1 {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0;
  }
  .eui-text-type2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
  }
  .eui-text-caption {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.4px;
    line-height: 22px;
  }
  .eui-text-overline {
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 1.5px;
    line-height: 20px;
    text-transform: uppercase;
  }
  .eui-text-center {
    text-align: center;
  }
  .eui-text-left {
    text-align: left;
  }
  .eui-text-right {
    text-align: right;
  }
  .eui-text-justify {
    text-align: justify;
  }
  .eui-font-family-f1 {
    font-family: var(--font-family-f1);
  }
}`;


/***/ }),

/***/ 9203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: function() { return /* binding */ euiTitleStyles; }
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6684);

const euiTitleStyles = (0,lit__WEBPACK_IMPORTED_MODULE_0__/* .css */ .AH) `
    .eui-title-super {
      font-size: 51px;
      line-height: 61px;
      font-weight: 700;
      letter-spacing: 1.33px;
    }
    .eui-title-type1 {
      font-weight: 700;
      font-size: 40px;
      line-height: 50px;
      letter-spacing: -0.6px;
    }
    .eui-title-type2 {
      font-weight: 700;
      font-size: 33px;
      line-height: 43px;
      letter-spacing: 0;
    }
    .eui-title-type3 {
      font-weight: 700;
      font-size: 25px;
      line-height: 35px;
      letter-spacing: 0.2px;
    }
    .eui-title-type4 {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0.14px;
    }
    .eui-title-type5 {
      font-weight: 700;
      font-size: 18px;
      line-height: 28px;
      letter-spacing: 0.14px;
    }
    .eui-title-type6 {
      font-weight: 900;
      font-size: 16px;
      line-height: 26px;
      letter-spacing: 0;
    }
    .eui-title-type7 {
      font-weight: 700;
      font-size: 16px;
      line-height: 26px;
      letter-spacing: 0;
    }
    .eui-subtitle-type1 {
      font-weight: 400;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0.2px;
    }
    .eui-subtitle-type2 {
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      letter-spacing: 0;
    }
    .eui-title-cookies {
      font-weight: var(--eui-title-cookies-font-weight);
      font-size: var(--eui-title-cookies-font-size);
      line-height: var(--eui-title-cookies-line-height);
      letter-spacing: var(--eui-title-cookies-letter-spacing);
      font-family: var(--eui-title-cookies-font-family);
      text-align: var(--eui-title-cookies-text-align);
      text-transform: var(--eui-title-cookies-text-transform);
    }
  }`;


/***/ }),

/***/ 3251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ euiUtilsStyles; }
/* harmony export */ });
/* harmony import */ var lit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6684);

const euiUtilsStyles = (0,lit__WEBPACK_IMPORTED_MODULE_0__/* .css */ .AH) `
    .eui-pl-0 {
        padding-left: 0px;
    }
    .eui-pr-0 {
        padding-right: 0px;
    }
    .eui-pt-0 {
        padding-top: 0px;
    }
    .eui-pb-0 {
        padding-bottom: 0px;
    }
    .eui-px-0 {
        padding-right: 0px;
        padding-left: 0px;
    }
    .eui-py-0 {
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .eui-ml-0 {
        margin-left: 0px;
    }
    .eui-mr-0 {
        margin-right: 0px;
    }
    .eui-mt-0 {
        margin-top: 0px;
    }
    .eui-mb-0 {
        margin-bottom: 0px;
    }
    .eui-mx-0 {
        margin-right: 0px;
        margin-left: 0px;
    }
    .eui-my-0 {
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .eui-pl-1 {
        padding-left: 4px;
    }
    .eui-pr-1 {
        padding-right: 4px;
    }
    .eui-pt-1 {
        padding-top: 4px;
    }
    .eui-pb-1 {
        padding-bottom: 4px;
    }
    .eui-px-1 {
        padding-right: 4px;
        padding-left: 4px;
    }
    .eui-py-1 {
        padding-top: 4px;
        padding-bottom: 4px;
    }
    .eui-ml-1 {
        margin-left: 4px;
    }
    .eui-mr-1 {
        margin-right: 4px;
    }
    .eui-mt-1 {
        margin-top: 4px;
    }
    .eui-mb-1 {
        margin-bottom: 4px;
    }
    .eui-mx-1 {
        margin-right: 4px;
        margin-left: 4px;
    }
    .eui-my-1 {
        margin-top: 4px;
        margin-bottom: 4px;
    }
    .eui-pl-2 {
        padding-left: 8px;
    }
    .eui-pr-2 {
        padding-right: 8px;
    }
    .eui-pt-2 {
        padding-top: 8px;
    }
    .eui-pb-2 {
        padding-bottom: 8px;
    }
    .eui-px-2 {
        padding-right: 8px;
        padding-left: 8px;
    }
    .eui-py-2 {
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .eui-ml-2 {
        margin-left: 8px;
    }
    .eui-mr-2 {
        margin-right: 8px;
    }
    .eui-mt-2 {
        margin-top: 8px;
    }
    .eui-mb-2 {
        margin-bottom: 8px;
    }
    .eui-mx-2 {
        margin-right: 8px;
        margin-left: 8px;
    }
    .eui-my-2 {
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .eui-pl-3 {
        padding-left: 16px;
    }
    .eui-pr-3 {
        padding-right: 16px;
    }
    .eui-pt-3 {
        padding-top: 16px;
    }
    .eui-pb-3 {
        padding-bottom: 16px;
    }
    .eui-px-3 {
        padding-right: 16px;
        padding-left: 16px;
    }
    .eui-py-3 {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .eui-ml-3 {
        margin-left: 16px;
    }
    .eui-mr-3 {
        margin-right: 16px;
    }
    .eui-mt-3 {
        margin-top: 16px;
    }
    .eui-mb-3 {
        margin-bottom: 16px;
    }
    .eui-mx-3 {
        margin-right: 16px;
        margin-left: 16px;
    }
    .eui-my-3 {
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .eui-pl-4 {
        padding-left: 24px;
    }
    .eui-pr-4 {
        padding-right: 24px;
    }
    .eui-pt-4 {
        padding-top: 24px;
    }
    .eui-pb-4 {
        padding-bottom: 24px;
    }
    .eui-px-4 {
        padding-right: 24px;
        padding-left: 24px;
    }
    .eui-py-4 {
        padding-top: 24px;
        padding-bottom: 24px;
    }
    .eui-ml-4 {
        margin-left: 24px;
    }
    .eui-mr-4 {
        margin-right: 24px;
    }
    .eui-mt-4 {
        margin-top: 24px;
    }
    .eui-mb-4 {
        margin-bottom: 24px;
    }
    .eui-mx-4 {
        margin-right: 24px;
        margin-left: 24px;
    }
    .eui-my-4 {
        margin-top: 24px;
        margin-bottom: 24px;
    }
    .eui-pl-5 {
        padding-left: 32px;
    }
    .eui-pr-5 {
        padding-right: 32px;
    }
    .eui-pt-5 {
        padding-top: 32px;
    }
    .eui-pb-5 {
        padding-bottom: 32px;
    }
    .eui-px-5 {
        padding-right: 32px;
        padding-left: 32px;
    }
    .eui-py-5 {
        padding-top: 32px;
        padding-bottom: 32px;
    }
    .eui-ml-5 {
        margin-left: 32px;
    }
    .eui-mr-5 {
        margin-right: 32px;
    }
    .eui-mt-5 {
        margin-top: 32px;
    }
    .eui-mb-5 {
        margin-bottom: 32px;
    }
    .eui-mx-5 {
        margin-right: 32px;
        margin-left: 32px;
    }
    .eui-my-5 {
        margin-top: 32px;
        margin-bottom: 32px;
    }
    .eui-pl-6 {
        padding-left: 40px;
    }
    .eui-pr-6 {
        padding-right: 40px;
    }
    .eui-pt-6 {
        padding-top: 40px;
    }
    .eui-pb-6 {
        padding-bottom: 40px;
    }
    .eui-px-6 {
        padding-right: 40px;
        padding-left: 40px;
    }
    .eui-py-6 {
        padding-top: 40px;
        padding-bottom: 40px;
    }
    .eui-ml-6 {
        margin-left: 40px;
    }
    .eui-mr-6 {
        margin-right: 40px;
    }
    .eui-mt-6 {
        margin-top: 40px;
    }
    .eui-mb-6 {
        margin-bottom: 40px;
    }
    .eui-mx-6 {
        margin-right: 40px;
        margin-left: 40px;
    }
    .eui-my-6 {
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .eui-pl-7 {
        padding-left: 48px;
    }
    .eui-pr-7 {
        padding-right: 48px;
    }
    .eui-pt-7 {
        padding-top: 48px;
    }
    .eui-pb-7 {
        padding-bottom: 48px;
    }
    .eui-px-7 {
        padding-right: 48px;
        padding-left: 48px;
    }
    .eui-py-7 {
        padding-top: 48px;
        padding-bottom: 48px;
    }
    .eui-ml-7 {
        margin-left: 48px;
    }
    .eui-mr-7 {
        margin-right: 48px;
    }
    .eui-mt-7 {
        margin-top: 48px;
    }
    .eui-mb-7 {
        margin-bottom: 48px;
    }
    .eui-mx-7 {
        margin-right: 48px;
        margin-left: 48px;
    }
    .eui-my-7 {
        margin-top: 48px;
        margin-bottom: 48px;
    }
    .eui-pl-8 {
        padding-left: 56px;
    }
    .eui-pr-8 {
        padding-right: 56px;
    }
    .eui-pt-8 {
        padding-top: 56px;
    }
    .eui-pb-8 {
        padding-bottom: 56px;
    }
    .eui-px-8 {
        padding-right: 56px;
        padding-left: 56px;
    }
    .eui-py-8 {
        padding-top: 56px;
        padding-bottom: 56px;
    }
    .eui-ml-8 {
        margin-left: 56px;
    }
    .eui-mr-8 {
        margin-right: 56px;
    }
    .eui-mt-8 {
        margin-top: 56px;
    }
    .eui-mb-8 {
        margin-bottom: 56px;
    }
    .eui-mx-8 {
        margin-right: 56px;
        margin-left: 56px;
    }
    .eui-my-8 {
        margin-top: 56px;
        margin-bottom: 56px;
    }
    .eui-pl-9 {
        padding-left: 64px;
    }
    .eui-pr-9 {
        padding-right: 64px;
    }
    .eui-pt-9 {
        padding-top: 64px;
    }
    .eui-pb-9 {
        padding-bottom: 64px;
    }
    .eui-px-9 {
        padding-right: 64px;
        padding-left: 64px;
    }
    .eui-py-9 {
        padding-top: 64px;
        padding-bottom: 64px;
    }
    .eui-ml-9 {
        margin-left: 64px;
    }
    .eui-mr-9 {
        margin-right: 64px;
    }
    .eui-mt-9 {
        margin-top: 64px;
    }
    .eui-mb-9 {
        margin-bottom: 64px;
    }
    .eui-mx-9 {
        margin-right: 64px;
        margin-left: 64px;
    }
    .eui-my-9 {
        margin-top: 64px;
        margin-bottom: 64px;
    }
    .eui-pl-10 {
        padding-left: 72px;
    }
    .eui-pr-10 {
        padding-right: 72px;
    }
    .eui-pt-10 {
        padding-top: 72px;
    }
    .eui-pb-10 {
        padding-bottom: 72px;
    }
    .eui-px-10 {
        padding-right: 72px;
        padding-left: 72px;
    }
    .eui-py-10 {
        padding-top: 72px;
        padding-bottom: 72px;
    }
    .eui-ml-10 {
        margin-left: 72px;
    }
    .eui-mr-10 {
        margin-right: 72px;
    }
    .eui-mt-10 {
        margin-top: 72px;
    }
    .eui-mb-10 {
        margin-bottom: 72px;
    }
    .eui-mx-10 {
        margin-right: 72px;
        margin-left: 72px;
    }
    .eui-my-10 {
        margin-top: 72px;
        margin-bottom: 72px;
    }
    .eui-pl-11 {
        padding-left: 80px;
    }
    .eui-pr-11 {
        padding-right: 80px;
    }
    .eui-pt-11 {
        padding-top: 80px;
    }
    .eui-pb-11 {
        padding-bottom: 80px;
    }
    .eui-px-11 {
        padding-right: 80px;
        padding-left: 80px;
    }
    .eui-py-11 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .eui-ml-11 {
        margin-left: 80px;
    }
    .eui-mr-11 {
        margin-right: 80px;
    }
    .eui-mt-11 {
        margin-top: 80px;
    }
    .eui-mb-11 {
        margin-bottom: 80px;
    }
    .eui-mx-11 {
        margin-right: 80px;
        margin-left: 80px;
    }
    .eui-my-11 {
        margin-top: 80px;
        margin-bottom: 80px;
    }
  }`;


/***/ }),

/***/ 2777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ cultureHelper; }
/* harmony export */ });
class cultureHelper {
    static getLangFromCulture(culture) {
        if (!culture)
            throw Error('culture can not be null or undefined.');
        const cultureParts = culture.toLowerCase().split('-').map((value) => {
            if (!value)
                throw Error(`Culture { ${culture} } is not valid.`);
            return value;
        });
        return cultureParts[0];
    }
    static generateCulture(country, lang, separator) {
        if (!country)
            throw Error('country can not be null or undefined.');
        if (!lang)
            throw Error('language can not be null or undefined.');
        return `${lang.toLowerCase()}${separator ? separator : '-'}${country.toUpperCase()}`;
    }
    static generateUrlCulture(culture) {
        if (!culture)
            throw Error('culture can not be null or undefined.');
        const cultureParts = culture.toLowerCase().split('-').map((value) => {
            if (!value)
                throw Error(`Culture { ${culture} } is not valid.`);
            return value;
        });
        return cultureHelper.generateCulture(cultureParts[1], cultureParts[0], '/');
    }
}


/***/ }),

/***/ 2616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  c: function() { return /* binding */ TranslateService; }
});

// UNUSED EXPORTS: Languages

;// ./assets/i18n/eui-literals.ca.json
var eui_literals_ca_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Acceptar totes les cookies","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Acceptar cookies","COOKIE-ACCEPTANCE.REJECT":"Rebutjar cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Rebutjar totes les cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Les cookies publicitaries permeten la gestió dels espais publicitaris de la web. A més, aquestes cookies poden ser de publicitat personalitzada i permetre així la gestió dels espais publicitaris de la web d\'acord amb el comportament i hàbits de navegació de l\'usuari, des d\'on s\'obté el seu perfil i permet personalitzar la publicitat que es mostra en el navegador de l\'usuari o altres perfils i xarxes socials de l\'usuari.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookies de publicitat","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Aquestes cookies ens permeten comptar les visites i fonts de trànsit per poder mesurar i millorar el rendiment de la nostra Plataforma.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Cookies d\'anàlisi","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Confirmar cookies seleccionades","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Canviar preferències","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Aquestes cookies permeten que la Plataforma ofereixi una millor funcionalitat i personalització.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Cookies de funcionalitat o personalització","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP utilitza cookies tècniques, de personalització, anàlisi i publicitàries, pròpies i de tercers, que tracten dades de connexió i/o del dispositiu, així com hàbits de navegació per facilitar-la, analitzar estadístiques de l\'ús del web i personalitzar publicitat. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Obtenir més informació</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Aquestes cookies són necessàries perquè la Plataforma funcioni i no es poden desactivar en els nostres sistemes.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookies estrictament necessàries","COOKIE-ACCEPTANCE.TITLE":"Configuració de cookies","MAINTENANCE.MESSAGE":"Estem treballant per millorar el servei. Disculpeu les molèsties.","MAINTENANCE.TITLE":"Estem en Manteniment","MAINTENANCE.THEME.APC.MESSAGE":"El nostre lloc web està en manteniment. Torna a comprovar-ho més tard. Disculpa les molèsties.","MAINTENANCE.THEME.APC.TITLE":"Tornem aviat!","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he rebut l\'e-mail amb el codi","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he rebut el SMS amb el codi","SECURITY-CODE.INSERT-CODE-HERE":"Introdueix el teu codi aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Sembla que el codi no és correcte, revisa el correu electrònic que t\'hem enviat.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Sembla que el codi no és correcte, revisa l\'SMS que t\'hem enviat.","SECURITY-CODE.RESEND-CODE":"Tornar a enviar","SECURITY-CODE.RESEND-CODE-IN":"Pots tornar a demanar el codi en:","TIMER.RESEND-CODE-IN":"Pots tornar a demanar el codi en:","NOTIFICATIONS_CENTER.DELETE":"Esborrar","NOTIFICATIONS_CENTER.OPEN":"Obrir","NOTIFICATIONS_CENTER.FILTERS.JOB_ALERTS":"Alertes de feina","NOTIFICATIONS_CENTER.FILTERS.MESSAGES":"Missatges","NOTIFICATIONS_CENTER.FILTERS.NOT_VIEWED":"No vistos","NOTIFICATIONS_CENTER.FILTERS.VIEWED":"Vistos","NOTIFICATIONS_CENTER.MARK_ALL_AS_READ":"Marcar tots com a llegit","NOTIFICATIONS_CENTER.MARK_AS_NOT_READ":"Marcar com a no llegit","NOTIFICATIONS_CENTER.NO_MESSAGE":"No tens missatges","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT":"Sense resultats","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT_BUTTON":"Borrar filtres","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT_DESCRIPTION":"Prova de cercar amb altres filtres","NOTIFICATIONS_CENTER.NO_TASKS":"Genial! No tens tasques pendents","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.ACTION":"Respondre","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.DESCRIPTION":"Tens una nova feina disponible, necessitem que responguis a la petició.","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.TITLE":"Nova crida","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.DESCRIPTION":"Tens pendent signar les clàusules contractuals","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.TITLE":"Clàusules contractuals","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.ACTION":"Gestionar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.DESCRIPTION":"Tens vestuari pendent de retornar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.TITLE":"Vestuari","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.ACTION":"Accedir","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.DESCRIPTION":"Tens cursos de formació pendents a la web","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.TITLE":"Cursos pendents","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.ACTION":"Renovar certificat","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.DESCRIPTION":"El certificat de discapacitat ha caducat, l\'has de renovar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.TITLE":"Certificat caducat","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.ACTION":"Accedir","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.DESCRIPTION":"Per facilitar una possible futura contractació, ens hauríeu d\'indicar el vostre número de seguretat social","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.TITLE":"Número de seguretat social","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.ACTION":"Afegir certificat","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.DESCRIPTION":"Afegeix el teu certificat de discapacitat","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.TITLE":"Certificat de discapacitat","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.DESCRIPTION":"Tens documentació pendent de signar a la web","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.TITLE":"Documents pendents","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.ACTION":"Afegir document","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.DESCRIPTION":"Adjunta el teu document d\'identitat","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.TITLE":"Document identificatiu","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.ACTION":"Contestar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.DESCRIPTION":"Ens agradaria tenir la teva opinió sobre la teva última contractació","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.TITLE":"Enquestes pendents","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.DESCRIPTION":"Tens pendent signar el document","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.TITLE":"Signatura document 145","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.ACTION":"Introduir la meva àrea","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.DESCRIPTION":"Configurar una àrea de cerca geolocalitzada us ajuda a trobar feines a prop vostre.","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.TITLE":"Àrea de cerca sense especificar","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATION_DELETE_OK":"Notificació eliminada correctament","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATION_READ_OK":"Notificació marcada com a llegida correctament","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATIONS_READ_OK":"Notificacions marcades com a llegides correctament","NOTIFICATIONS_CENTER.NOTIFICATIONS.TITLE":"Notificacions","NOTIFICATIONS_CENTER.OFFICE_MESSAGE":"Missatge d\'oficina","NOTIFICATIONS_CENTER.TASKS.TITLE":"Tasques","NOTIFICATIONS_CENTER.TITLE":"Centre de notificacions","NOTIFICATIONS_CENTER_CLIENT.TITLE":"Centre de notificacions","NOTIFICATIONS_CENTER_CLIENT.DELETE":"Esborrar","NOTIFICATIONS_CENTER_CLIENT.OPEN":"Obrir","NOTIFICATIONS_CENTER_CLIENT.FILTERS.MESSAGES":"Missatges","NOTIFICATIONS_CENTER_CLIENT.FILTERS.NOT_VIEWED":"No vistos","NOTIFICATIONS_CENTER_CLIENT.FILTERS.VIEWED":"Vistos","NOTIFICATIONS_CENTER_CLIENT.MARK_ALL_AS_READ":"Marcar tots como llegits","NOTIFICATIONS_CENTER_CLIENT.MARK_AS_NOT_READ":"Marcar como no llegit","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE":"No tens missatges","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT":"Sense resultats","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT_BUTTON":"Esborrar filtres","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT_DESCRIPTION":"Prova de cercar amb altres filtres","NOTIFICATIONS_CENTER_CLIENT.NO_TASKS":"¡Genial! No tens tasques pendents","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATION_DELETE_OK":"Notificació esborrada correctament","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATION_READ_OK":"Notificació marcada como llegida correctament","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATIONS_READ_OK":"Notificacions marcades como llegides correctament","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.TITLE":"Notificacions","NOTIFICATIONS_CENTER_CLIENT.OFFICE_MESSAGE":"Missatge d\'oficina","NOTIFICATIONS_CENTER_CLIENT.TASKS.TITLE":"Tasques","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.TITLE":"CPDs pendents de firmar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.DESCRIPTION":"Hi ha CPDs pendents de signar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.ACTION":"Firmar CPDs","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.TITLE":"CPDs pendents de revisar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.DESCRIPTION":"CPDs pendents de revisar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.ACTION":"Revisar CPDs","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.TITLE":"Certificat de signatura pendent","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.DESCRIPTION":"Necessites generar un certificat digital","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.ACTION":"Generar certificat","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.TITLE":"Certificat de firma caducat","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.DESCRIPTION":"Has de renovar el certificat digital","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.ACTION":"Renovar certificat","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.TITLE":"Hores pendents","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.DESCRIPTION":"Hi ha hores pendent de gestionar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.ACTION":"Gestionar hores","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.TITLE":"Factures pendents","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.DESCRIPTION":"Hi ha factures pendents de regular","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.ACTION":"Veure factures","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.TITLE":"Factures vençudes","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.DESCRIPTION":"Hi ha factures pendents de regular","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.ACTION":"Veure factures","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.TITLE":"Comandes pendents","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.DESCRIPTION":"Hi ha comandes amb candidats a gestionar","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.ACTION":"Revisar comandes"}');
var i18n_eui_literals_ca_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_ca_namespaceObject, 2);
;// ./assets/i18n/eui-literals.es.json
var eui_literals_es_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Aceptar todas las cookies","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Aceptar cookies","COOKIE-ACCEPTANCE.REJECT":"Rechazar cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Rechazar todas las cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Las cookies publicitarias permiten la gestión de los espacios publicitarios de la web. Además, estas cookies pueden ser de publicidad personalizada y permitir así la gestión de los espacios publicitarios de la web en base al comportamiento y hábitos de navegación de usuario, de donde se obtiene su perfil y permiten personalizar la publicidad que se muestra en el navegador del usuario u otros perfiles y redes sociales del usuario.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookies de publicidad","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Estas cookies nos permiten contar las visitas y fuentes de circulación para poder medir y mejorar el desempeño de nuestra Plataforma.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Cookies de análisis","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Confirmar cookies selecionadas","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Cambiar preferencias","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Estas cookies permiten que la Plataforma ofrezca una mejor funcionalidad y personalización.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Cookies de funcionalidad o personalización","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP utiliza cookies técnicas, de personalización, análisis y publicitarias, propias y de terceros, que tratan datos de conexión y/o del dispositivo, así como hábitos de navegación para facilitarle la misma, analizar estadísticas del uso de la web y personalizar publicidad. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Obtener más información</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Estas cookies son necesarias para que la Plataforma funcione y no se pueden desactivar en nuestros sistemas.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookies estrictamente necesarias","COOKIE-ACCEPTANCE.TITLE":"Configuración de cookies","MAINTENANCE.MESSAGE":"Estamos trabajando para mejorar el servicio. Disculpen las molestias.","MAINTENANCE.TITLE":"Estamos en Mantenimiento","MAINTENANCE.THEME.APC.MESSAGE":"Nuestro sitio web está en mantenimiento. Por favor, vuelve a comprobarlo más tarde. Disculpa las molestias.","MAINTENANCE.THEME.APC.TITLE":"¡Volvemos pronto!","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he recibido el e-mail con el código,","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he recibido el SMS con el código,","SECURITY-CODE.INSERT-CODE-HERE":"Inserta tu código aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Parece que el código no es correcto, revisa el e-mail que te hemos enviado.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Parece que el código no es correcto, revisa el SMS que te hemos enviado.","SECURITY-CODE.RESEND-CODE":"Volver a enviar","SECURITY-CODE.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:","TIMER.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:","NOTIFICATIONS_CENTER.DELETE":"Borrar","NOTIFICATIONS_CENTER.OPEN":"Abrir","NOTIFICATIONS_CENTER.FILTERS.JOB_ALERTS":"Alertas de empleo","NOTIFICATIONS_CENTER.FILTERS.MESSAGES":"Mensajes","NOTIFICATIONS_CENTER.FILTERS.NOT_VIEWED":"No vistos","NOTIFICATIONS_CENTER.FILTERS.VIEWED":"Vistos","NOTIFICATIONS_CENTER.MARK_ALL_AS_READ":"Marcar todos como leído","NOTIFICATIONS_CENTER.MARK_AS_NOT_READ":"Marcar como no leído","NOTIFICATIONS_CENTER.NO_MESSAGE":"No tienes mensajes","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT":"Sin resultados","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT_BUTTON":"Borrar filtros","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT_DESCRIPTION":"Prueba de buscar con otros filtros","NOTIFICATIONS_CENTER.NO_TASKS":"¡Genial! No tienes tareas pendientes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.ACTION":"Responder","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.DESCRIPTION":"Tienes un nuevo trabajo disponible, necesitamos que respondas la petición","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.TITLE":"Nuevo llamamiento","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.DESCRIPTION":"Tienes pendiente firmar las cláusulas contractuales","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.TITLE":"Cláusulas contractuales","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.ACTION":"Gestionar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.DESCRIPTION":"Tienes vestuario pendiente de devolver","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.TITLE":"Vestuario","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.ACTION":"Acceder","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.DESCRIPTION":"Tienes cursos de formación pendientes en la web","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.TITLE":"Cursos pendientes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.ACTION":"Renovar certificado","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.DESCRIPTION":"El certificado de discapacidad ha caducado, debes renovarlo","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.TITLE":"Certificado caducado","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.ACTION":"Acceder","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.DESCRIPTION":"Para facilitar una posible futura contratación, deberías indicarnos tu número de seguridad social","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.TITLE":"Número de seguridad social","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.ACTION":"Añadir certificado","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.DESCRIPTION":"Añade tu certificado de discapacidad","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.TITLE":"Certificado de discapacidad","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.DESCRIPTION":"Tienes documentación pendiente para firmar en la web","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.TITLE":"Documentos pendientes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.ACTION":"Añadir documento","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.DESCRIPTION":"Adjunta tu documento de identidad","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.TITLE":"Documento identificativo","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.ACTION":"Contestar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.DESCRIPTION":"Nos gustaría tener tu opinión sobre tu última contratación","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.TITLE":"Encuestas pendientes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.DESCRIPTION":"Tienes pendiente firmar el documento","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.TITLE":"Firma documento 145","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.ACTION":"Introducir mi área","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.DESCRIPTION":"Configurar un área de búsqueda geolocalizada te ayuda a encontrar trabajos cerca de ti.","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.TITLE":"Área de búsqueda sin especificar","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATION_DELETE_OK":"Notificación eliminada correctamente","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATION_READ_OK":"Notificación marcada como leída correctamente","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATIONS_READ_OK":"Notificaciones marcadas como leídas correctamente","NOTIFICATIONS_CENTER.NOTIFICATIONS.TITLE":"Notificaciones","NOTIFICATIONS_CENTER.OFFICE_MESSAGE":"Mensaje de oficina","NOTIFICATIONS_CENTER.TASKS.TITLE":"Tareas","NOTIFICATIONS_CENTER.TITLE":"Centro de notificaciones","NOTIFICATIONS_CENTER_CLIENT.TITLE":"Centro de notificaciones","NOTIFICATIONS_CENTER_CLIENT.DELETE":"Borrar","NOTIFICATIONS_CENTER_CLIENT.OPEN":"Abrir","NOTIFICATIONS_CENTER_CLIENT.FILTERS.MESSAGES":"Mensajes","NOTIFICATIONS_CENTER_CLIENT.FILTERS.NOT_VIEWED":"No vistos","NOTIFICATIONS_CENTER_CLIENT.FILTERS.VIEWED":"Vistos","NOTIFICATIONS_CENTER_CLIENT.MARK_ALL_AS_READ":"Marcar todos como leído","NOTIFICATIONS_CENTER_CLIENT.MARK_AS_NOT_READ":"Marcar como no leído","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE":"No tienes mensajes","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT":"Sin resultados","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT_BUTTON":"Borrar filtros","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT_DESCRIPTION":"Prueba de buscar con otros filtros","NOTIFICATIONS_CENTER_CLIENT.NO_TASKS":"¡Genial! No tienes tareas pendientes","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATION_DELETE_OK":"Notificación eliminada correctamente","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATION_READ_OK":"Notificación marcada como leída correctamente","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATIONS_READ_OK":"Notificaciones marcadas como leídas correctamente","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.TITLE":"Notificaciones","NOTIFICATIONS_CENTER_CLIENT.OFFICE_MESSAGE":"Mensaje de oficina","NOTIFICATIONS_CENTER_CLIENT.TASKS.TITLE":"Tareas","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.TITLE":"CPDs pendientes de firmar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.DESCRIPTION":"Hay CPDs pendientes de firmar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.ACTION":"Firmar CPDs","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.TITLE":"CPDs pendientes de revisar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.DESCRIPTION":"CPDs pendientes de revisar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.ACTION":"Revisar CPDs","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.TITLE":"Certificado de firma pendiente","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.DESCRIPTION":"Debes generar un certificado digital","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.ACTION":"Generar certificado","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.TITLE":"Certificado de firma caducado","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.DESCRIPTION":"Debes renovar el certificado digital","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.ACTION":"Renovar certificado","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.TITLE":"Horas pendientes","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.DESCRIPTION":"Hay horas pendientes de gestionar","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.ACTION":"Gestionar horas","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.TITLE":"Facturas pendientes","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.DESCRIPTION":"Regulariza el estado de las facturas pendientes","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.ACTION":"Ver facturas","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.TITLE":"Facturas vencidas","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.DESCRIPTION":"Hay facturas pendientes de regular","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.ACTION":"Ver facturas","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.TITLE":"Pedidos pendientes","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.DESCRIPTION":"Hay pedidos con candidatos a gestionar","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.ACTION":"Revisar pedidos"}');
var i18n_eui_literals_es_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_es_namespaceObject, 2);
;// ./assets/i18n/eui-literals.pt.json
var eui_literals_pt_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Aceitar cookies ","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Aceitar cookies ","COOKIE-ACCEPTANCE.REJECT":"Recusar cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Recusar todos os cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Os cookies de publicidade permitem a gestão de espaços publicitários no site. Além disso, estes cookies podem ser para publicidade personalizada e assim permitir a gestão dos espaços publicitários do site de acordo com o comportamento e hábitos de navegação do utilizador, de onde se obtém o seu perfil e permite a personalização da publicidade que é apresentada no navegador do utilizador ou noutros perfis e redes sociais do utilizador.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookies de publicidade","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Estes cookies permitem-nos contar visitas e fontes de circulação para medir e melhorar o desempenho da nossa plataforma.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Cookies de análise","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Aceitar cookies","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Alterar preferências","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Esses cookies permitem que a Plataforma ofereça melhor funcionalidade e personalização.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Cookies de funcionalidade ou personalização","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"O EUROFIRMS GROUP utiliza cookies técnicos, de personalização, de análise e de publicidade, próprios e de terceiros, que processam dados de ligação e/ou dispositivo, bem como hábitos de navegação para facilitar a navegação, analisar estatísticas sobre a utilização do site e personalizar a publicidade. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Saber mais</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Esses cookies são necessários para o funcionamento da Plataforma e não podem ser desativados em nossos sistemas.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookies estritamente necessários","COOKIE-ACCEPTANCE.TITLE":"Configurações de cookies","MAINTENANCE.MESSAGE":"Estamos trabalhando para melhorar o serviço. Desculpem as molestias.","MAINTENANCE.TITLE":"Estamos em manutenção","MAINTENANCE.THEME.APC.MESSAGE":"Nosso site está em manutenção. Por favor, volte mais tarde. Desculpem os transtornos.","MAINTENANCE.THEME.APC.TITLE":"Voltaremos em breve!","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"Não recebi o e-mail com o código","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"Eu não refutei o SMS com o código","SECURITY-CODE.INSERT-CODE-HERE":"Insira seu código aqui:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"Opa! Parece que o código não está correto, verifique o e-mail que lhe enviamos.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"Opa! Parece que o código não está correto, verifique o SMS que lhe enviamos.","SECURITY-CODE.RESEND-CODE":"Reenviar","SECURITY-CODE.RESEND-CODE-IN":"Os potes voltam para solicitar o código em:","TIMER.RESEND-CODE-IN":"Você pode solicitar o código novamente em:","NOTIFICATIONS_CENTER.DELETE":"Excluir","NOTIFICATIONS_CENTER.OPEN":"Abrir","NOTIFICATIONS_CENTER.FILTERS.JOB_ALERTS":"Alertas de emprego","NOTIFICATIONS_CENTER.FILTERS.MESSAGES":"Mensagens","NOTIFICATIONS_CENTER.FILTERS.NOT_VIEWED":"Não visto","NOTIFICATIONS_CENTER.FILTERS.VIEWED":"Vistos","NOTIFICATIONS_CENTER.MARK_ALL_AS_READ":"Marcar tudo como lido","NOTIFICATIONS_CENTER.MARK_AS_NOT_READ":"Marcar como não lido","NOTIFICATIONS_CENTER.NO_MESSAGE":"Não existem mensagens","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT":"Sem resultados","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT_BUTTON":"Apagar filtros","NOTIFICATIONS_CENTER.NO_MESSAGE_RESULT_DESCRIPTION":"Tente pesquisar com outros filtros","NOTIFICATIONS_CENTER.NO_TASKS":"Não tens tarefas pendentes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.ACTION":"Responder","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.DESCRIPTION":"Você tem um novo emprego disponível, precisamos que você responda à solicitação.","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CALL.TITLE":"Novo apelo","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.DESCRIPTION":"Você tem pendente para assinar as cláusulas contratuais","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLACON.TITLE":"Cláusulas contratuais","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.ACTION":"Administrar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.DESCRIPTION":"Você tem vestuário com retorno pendente","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.CLOTHING.TITLE":"Vestiário","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.ACTION":"Acesso","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.DESCRIPTION":"Você tem cursos de treinamento pendentes na web","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.COURSES.TITLE":"Cursos pendentes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.ACTION":"Renovar o certificado","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.DESCRIPTION":"O certificado de invalidez expirou, você deve renová-lo","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_EXPIRED.TITLE":"Certificado expirado","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.ACTION":"Acessar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.DESCRIPTION":"Para facilitar uma possível contratação futura, deverá indicar-nos o seu número de Segurança Social","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SOCIAL_SECURITY_NUMBER.TITLE":"Número da Segurança Social","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.ACTION":"Acrescentar certificado","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.DESCRIPTION":"Adicione seu certificado de deficiência","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DISABILITY_PENDING.TITLE":"Certificado de deficiência","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.ACTION":"Assinar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.DESCRIPTION":"Você tem documentação pendente para assinar na web","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.DOCUMENTS.TITLE":"Documentos pendentes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.ACTION":"Adicionar documento","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.DESCRIPTION":"Anexar documento de identidade","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.IPF.TITLE":"Documento de identificação","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.ACTION":"Responder","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.DESCRIPTION":"Gostaríamos de ter sua opinião sobre sua última contratação","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.SURVEYS.TITLE":"Questionários pendentes","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.ACTION":"Firmar","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.DESCRIPTION":"Você tem que assinar o documento","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.MODEL145.TITLE":"Assinar documento 145","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.ACTION":"Entre na minha área","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.DESCRIPTION":"Configurar uma área de pesquisa geolocalizada ajuda-o a encontrar empregos perto de si.","NOTIFICATIONS_CENTER.NOTIFICATIONS_TYPES.LOCATION.TITLE":"Área de pesquisa não especificada","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATION_DELETE_OK":"Notificação eliminada com sucesso","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATION_READ_OK":"Notificação marcada como lida com sucesso","NOTIFICATIONS_CENTER.NOTIFICATIONS.NOTIFICATIONS_READ_OK":"Notificações marcadas como lidas com sucesso","NOTIFICATIONS_CENTER.NOTIFICATIONS.TITLE":"Notificações","NOTIFICATIONS_CENTER.OFFICE_MESSAGE":"Mensagem do escritório","NOTIFICATIONS_CENTER.TASKS.TITLE":"Tarefas","NOTIFICATIONS_CENTER.TITLE":"Centro de notificações","NOTIFICATIONS_CENTER_CLIENT.TITLE":"Central de Notificações","NOTIFICATIONS_CENTER_CLIENT.DELETE":"Excluir","NOTIFICATIONS_CENTER_CLIENT.OPEN":"Abrir","NOTIFICATIONS_CENTER_CLIENT.FILTERS.MESSAGES":"Mensagens","NOTIFICATIONS_CENTER_CLIENT.FILTERS.NOT_VIEWED":"Não visto","NOTIFICATIONS_CENTER_CLIENT.FILTERS.VIEWED":"Visto","NOTIFICATIONS_CENTER_CLIENT.MARK_ALL_AS_READ":"Marcar tudo como lido","NOTIFICATIONS_CENTER_CLIENT.MARK_AS_NOT_READ":"Marcar como não lido","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE":"Não tem mensagens","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT":"Nenhum resultado","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT_BUTTON":"Limpar filtros","NOTIFICATIONS_CENTER_CLIENT.NO_MESSAGE_RESULT_DESCRIPTION":"Tente pesquisar com outros filtros","NOTIFICATIONS_CENTER_CLIENT.NO_TASKS":"Brilhante! Não tem tarefas pendentes","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATION_DELETE_OK":"Notificação removida com sucesso","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATION_READ_OK":"Notificação marcada como lida com sucesso","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.NOTIFICATIONS_READ_OK":"Notificações marcadas como lidas com sucesso","NOTIFICATIONS_CENTER_CLIENT.NOTIFICATIONS.TITLE":"Notificações","NOTIFICATIONS_CENTER_CLIENT.OFFICE_MESSAGE":"Mensagem do escritório","NOTIFICATIONS_CENTER_CLIENT.TASKS.TITLE":"Tarefas","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.TITLE":"CUTTs pendentes de assinatura","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.DESCRIPTION":"Existem CPD pendentes de assinatura","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_PENDING.ACTION":"Assinar CUTTs","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.TITLE":"DPC com revisão pendente","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.DESCRIPTION":"DPC com revisão pendente","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_REVIEW.ACTION":"Reveja os CUTTs","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.TITLE":"Certificado de assinatura CUTT pendente","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.DESCRIPTION":"Precisa de um certificado digital para assinar CUTTs","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE.ACTION":"Criar certificado","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.TITLE":"Certificado de assinatura expirado","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.DESCRIPTION":"Deve renovar o certificado digital","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_CERTIFICATE_EXPIRED.ACTION":"Renovar certificado","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.TITLE":"Horário pendente","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.DESCRIPTION":"Há horas pendentes para gerir","NOTIFICATIONS_CENTER_CLIENT.TASKS.CPDS_HOURS_ENTRY.ACTION":"Gerir horas","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.TITLE":"Faturas pendentes","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.DESCRIPTION":"Regularize o estado das faturas pendentes","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_INVOICES.ACTION":"Ver faturas","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.TITLE":"Faturas vencidas","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.DESCRIPTION":"Existem faturas pendentes de regulamentação","NOTIFICATIONS_CENTER_CLIENT.TASKS.EXPIRED_INVOICES.ACTION":"Ver faturas","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.TITLE":"Pedidos pendentes","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.DESCRIPTION":"Existem pedidos com candidatos para gerir","NOTIFICATIONS_CENTER_CLIENT.TASKS.PENDING_ORDERS.ACTION":"Rever pedidos"}');
var i18n_eui_literals_pt_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_pt_namespaceObject, 2);
;// ./assets/i18n/eui-literals.it.json
var eui_literals_it_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":" Accetta tutti i cookie","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":" Accetta i cookie ","COOKIE-ACCEPTANCE.REJECT":"Rifiuta i cookie","COOKIE-ACCEPTANCE.REJECT-ALL":"Rifiuta tutti i cookie","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"I cookie pubblicitari consentono la gestione degli spazi pubblicitari sul sito web. Inoltre, questi cookie possono essere di tipo pubblicitario personalizzato e quindi consentire la gestione degli spazi pubblicitari sul sito web in base al comportamento e alle abitudini di navigazione dell\'utente, da dove si ottiene il suo profilo e consente la personalizzazione della pubblicità visualizzata nel browser dell\'utente o in altri profili e social network dell\'utente.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookie pubblicitari","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":" Questi cookie ci consentono di contare le visite e le fonti di circolazione al fine di misurare e migliorare le prestazioni della nostra Piattaforma.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":" Cookie di analisi ","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":" Conferma i cookie selezionati ","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Cambia preferenze","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":" Questi cookie consentono alla Piattaforma di offrire una migliore funzionalità e personalizzazione. ","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":" Cookie di funzionalità o personalizzazione ","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP utilizza cookie tecnici, di personalizzazione, di analisi e pubblicitari propri e di terze parti, che elaborano dati di connessione e/o del dispositivo, nonché abitudini di navigazione per facilitare la navigazione, analizzare le statistiche sull\'utilizzo del sito web e personalizzare la pubblicità. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Scopri di più</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Questi cookie sono necessari per il funzionamento della Piattaforma e non possono essere disattivati ​​nei nostri sistemi.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookie strettamente necessari ","COOKIE-ACCEPTANCE.TITLE":"Impostazioni dei cookie","MAINTENANCE.MESSAGE":"Stiamo lavorando per migliorare il servizio. Ci dispiace per l\'inconvenienza","MAINTENANCE.TITLE":"Siamo in manutenzione","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he recibido el e-mail con el código,","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he recibido el SMS con el código,","SECURITY-CODE.INSERT-CODE-HERE":"Inserta tu código aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Parece que el código no es correcto, revisa el e-mail que te hemos enviado.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Parece que el código no es correcto, revisa el SMS que te hemos enviado.","SECURITY-CODE.RESEND-CODE":"Volver a enviar","SECURITY-CODE.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:","TIMER.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:"}');
var i18n_eui_literals_it_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_it_namespaceObject, 2);
;// ./assets/i18n/eui-literals.cl.json
var eui_literals_cl_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Aceptar todas las cookies","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Aceptar cookies","COOKIE-ACCEPTANCE.REJECT":"Rechazar cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Rechazar todas las cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Las cookies publicitarias permiten la gestión de los espacios publicitarios de la web. Además, estas cookies pueden ser de publicidad personalizada y permitir así la gestión de los espacios publicitarios de la web en base al comportamiento y hábitos de navegación de usuario, de donde se obtiene su perfil y permiten personalizar la publicidad que se muestra en el navegador del usuario u otros perfiles y redes sociales del usuario.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookies de publicidad","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Estas cookies nos permiten contar las visitas y fuentes de circulación para poder medir y mejorar el desempeño de nuestra Plataforma.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Cookies de análisis","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Confirmar cookies selecionadas","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Cambiar preferencias","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Estas cookies permiten que la Plataforma ofrezca una mejor funcionalidad y personalización.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Cookies de funcionalidad o personalización","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP utiliza cookies técnicas, de personalización, análisis y publicitarias, propias y de terceros, que tratan datos de conexión y/o del dispositivo, así como hábitos de navegación para facilitarle la misma, analizar estadísticas del uso de la web y personalizar publicidad. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Obtener más información</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Estas cookies son necesarias para que la Plataforma funcione y no se pueden desactivar en nuestros sistemas.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookies estrictamente necesarias","COOKIE-ACCEPTANCE.TITLE":"Configuración de cookies","MAINTENANCE.MESSAGE":"Estamos trabajando para mejorar el servicio. Disculpen las molestias.","MAINTENANCE.TITLE":"Estamos en Mantenimiento","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he recibido el e-mail con el código,","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he recibido el SMS con el código,","SECURITY-CODE.INSERT-CODE-HERE":"Inserta tu código aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Parece que el código no es correcto, revisa el e-mail que te hemos enviado.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Parece que el código no es correcto, revisa el SMS que te hemos enviado.","SECURITY-CODE.RESEND-CODE":"Volver a enviar","SECURITY-CODE.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:","TIMER.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:"}');
var i18n_eui_literals_cl_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_cl_namespaceObject, 2);
;// ./assets/i18n/eui-literals.nl.json
var eui_literals_nl_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Alle cookies accepteren","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Cookies accepteren","COOKIE-ACCEPTANCE.REJECT":"Cookies weigeren","COOKIE-ACCEPTANCE.REJECT-ALL":"Alle cookies weigeren","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Advertentiecookies maken het beheer van advertentieruimtes op de website mogelijk. Bovendien kunnen deze cookies worden gebruikt voor gepersonaliseerde advertenties en maken ze het beheer van de advertentieruimtes op de website mogelijk op basis van het gedrag en de surfgewoonten van de gebruiker, van waaruit zijn profiel wordt verkregen en maakt het mogelijk de advertenties te personaliseren die worden weergegeven in de browser van de gebruiker of andere profielen en sociale netwerken van de gebruiker.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Advertentiecookies","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Met deze cookies kunnen we het aantal bezoekers en de herkomst bepalen om de ontwikkeling van ons Platform te meten en te verbeteren.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Analysecookies","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Geselecteerde cookies bevestigen","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Cookies configureren","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Met deze cookies kan het Platform een betere functionaliteit en persoonlijke optimalisatie bieden.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Functionele of personalisatiecookies","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP maakt gebruik van eigen technische, personalisatie-, analyse- en advertentiecookies en cookies van derden. Deze cookies verwerken verbindings- en/of apparaatgegevens, evenals surfgedrag om het surfen te vergemakkelijken, statistieken over het gebruik van de website te analyseren en advertenties te personaliseren. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Meer informatie</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Deze cookies zijn nodig om het Platform te laten functioneren en kunnen niet worden uitgeschakeld in ons systeem.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Strikt benodigde cookies","COOKIE-ACCEPTANCE.TITLE":"Configuratie van cookies","MAINTENANCE.MESSAGE":"Wij werken eraan om onze diensten te verbeteren. Onze excuses voor het ongemak.","MAINTENANCE.TITLE":"Website in onderhoud","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he rebut l\'e-mail amb el codi","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he rebut el SMS amb el codi","SECURITY-CODE.INSERT-CODE-HERE":"Introdueix el teu codi aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Sembla que el codi no és correcte, revisa el correu electrònic que t\'hem enviat.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Sembla que el codi no és correcte, revisa l\'SMS que t\'hem enviat.","SECURITY-CODE.RESEND-CODE":"Tornar a enviar","SECURITY-CODE.RESEND-CODE-IN":"Pots tornar a demanar el codi en:","TIMER.RESEND-CODE-IN":"Pots tornar a demanar el codi en:"}');
var i18n_eui_literals_nl_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_nl_namespaceObject, 2);
;// ./assets/i18n/eui-literals.en.json
var eui_literals_en_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Accept all cookies","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Accept cookies","COOKIE-ACCEPTANCE.REJECT":"Reject cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Reject all cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Advertising cookies allow the management of advertising spaces on the website. In addition, these cookies can be personalized advertising and thus allow the management of advertising spaces on the website according to the user\'s behavior and browsing habits, from where their profile is obtained and allows the personalization of the advertising that is displayed in the user\'s browser or other profiles and social networks of the user.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Advertising cookies","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"These cookies enable us to count the number of visits and traffic sources in order to measure and improve our Platform\'s performance.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Analytical cookies","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Confirm selected cookies","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Change preferences","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"These cookies enable the Platform to offer a greater degree of functionality and personalisation.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Functionality or personalisation cookies","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP uses its own and third-party technical, personalization, analysis and advertising cookies, which process connection and/or device data, as well as browsing habits to facilitate browsing, analyze statistics on website usage and personalize advertising. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Find out more</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"These cookies are essential to enable the Platform to operate and they cannot be disabled in our systems.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Strictly essential cookies","COOKIE-ACCEPTANCE.TITLE":"Cookie settings","MAINTENANCE.MESSAGE":"Estamos trabajando para mejorar el servicio. Disculpen las molestias.","MAINTENANCE.TITLE":"Estamos en Mantenimiento","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he recibido el e-mail con el código,","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he recibido el SMS con el código,","SECURITY-CODE.INSERT-CODE-HERE":"Inserta tu código aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Parece que el código no es correcto, revisa el e-mail que te hemos enviado.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Parece que el código no es correcto, revisa el SMS que te hemos enviado.","SECURITY-CODE.RESEND-CODE":"Volver a enviar","SECURITY-CODE.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:","TIMER.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:"}');
var i18n_eui_literals_en_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_en_namespaceObject, 2);
;// ./assets/i18n/eui-literals.fr.json
var eui_literals_fr_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Accepter tous les cookies","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Accepter les cookies","COOKIE-ACCEPTANCE.REJECT":"Refuser les cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Refuser tous les cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Les cookies publicitaires permettent la gestion des espaces publicitaires sur le site. En outre, ces cookies peuvent être destinés à la publicité personnalisée et ainsi permettre la gestion des espaces publicitaires du site Web en fonction du comportement et des habitudes de navigation de l\'utilisateur, à partir desquels son profil est obtenu et permet la personnalisation de la publicité qui s\'affiche dans le navigateur de l\'utilisateur ou d\'autres profils et réseaux sociaux de l\'utilisateur.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookies publicitaires","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Ces cookies nous permettent de compter les visites et les sources de trafic afin de mesurer et d\'améliorer les performances de notre Plateforme.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Cookies d\'analyse","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Confirmer les cookies sélectionnés","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Modifier les préférences","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Ces cookies permettent à la Plateforme d\'offrir de meilleures fonctionnalités et une meilleure personnalisation.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Cookies de fonctionnalité ou de personnalisation","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP utilise ses propres cookies techniques, de personnalisation, d\'analyse et de publicité, ainsi que ceux de tiers, qui traitent les données de connexion et/ou de l\'appareil, ainsi que les habitudes de navigation pour faciliter la navigation, analyser les statistiques d\'utilisation du site Web et personnaliser la publicité. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>En savoir plus</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Ces cookies sont nécessaires au bon fonctionnement de la Plateforme et ne peuvent pas être désactivés sur nos systèmes.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookies strictement nécessaires","COOKIE-ACCEPTANCE.TITLE":"Paramètres des cookies","MAINTENANCE.MESSAGE":"Nous faisons le nécessaire pour améliorer notre service. Nous nous excusons pour tout désagrément.","MAINTENANCE.TITLE":"Nous sommes en maintenance","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he rebut l\'e-mail amb el codi","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he rebut el SMS amb el codi","SECURITY-CODE.INSERT-CODE-HERE":"Introdueix el teu codi aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Sembla que el codi no és correcte, revisa el correu electrònic que t\'hem enviat.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Sembla que el codi no és correcte, revisa l\'SMS que t\'hem enviat.","SECURITY-CODE.RESEND-CODE":"Tornar a enviar","SECURITY-CODE.RESEND-CODE-IN":"Pots tornar a demanar el codi en:","TIMER.RESEND-CODE-IN":"Pots tornar a demanar el codi en:"}');
var i18n_eui_literals_fr_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_fr_namespaceObject, 2);
;// ./assets/i18n/eui-literals.pe.json
var eui_literals_pe_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Aceptar todas las cookies","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Aceptar cookies","COOKIE-ACCEPTANCE.REJECT":"Rechazar cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Rechazar todas las cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Las cookies publicitarias permiten la gestión de los espacios publicitarios de la web. Además, estas cookies pueden ser de publicidad personalizada y permitir así la gestión de los espacios publicitarios de la web en base al comportamiento y hábitos de navegación de usuario, de donde se obtiene su perfil y permiten personalizar la publicidad que se muestra en el navegador del usuario u otros perfiles y redes sociales del usuario.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookies de publicidad","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Estas cookies nos permiten contar las visitas y fuentes de circulación para poder medir y mejorar el desempeño de nuestra Plataforma.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Cookies de análisis","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Confirmar cookies selecionadas","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Cambiar preferencias","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Estas cookies permiten que la Plataforma ofrezca una mejor funcionalidad y personalización.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Cookies de funcionalidad o personalización","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"EUROFIRMS GROUP utiliza cookies técnicas, de personalización, análisis y publicitarias, propias y de terceros, que tratan datos de conexión y/o del dispositivo, así como hábitos de navegación para facilitarle la misma, analizar estadísticas del uso de la web y personalizar publicidad. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Obtener más información</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Estas cookies son necesarias para que la Plataforma funcione y no se pueden desactivar en nuestros sistemas.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookies estrictamente necesarias","COOKIE-ACCEPTANCE.TITLE":"Configuración de cookies","MAINTENANCE.MESSAGE":"Estamos trabajando para mejorar el servicio. Disculpen las molestias.","MAINTENANCE.TITLE":"Estamos en Mantenimiento","MAINTENANCE.THEME.APC.MESSAGE":"Nuestro sitio web está en mantenimiento. Por favor, vuelve a comprobarlo más tarde. Disculpa las molestias.","MAINTENANCE.THEME.APC.TITLE":"¡Volvemos pronto!","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"No he recibido el e-mail con el código,","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"No he recibido el SMS con el código,","SECURITY-CODE.INSERT-CODE-HERE":"Inserta tu código aquí:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"¡Ups! Parece que el código no es correcto, revisa el e-mail que te hemos enviado.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"¡Ups! Parece que el código no es correcto, revisa el SMS que te hemos enviado.","SECURITY-CODE.RESEND-CODE":"Volver a enviar","SECURITY-CODE.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:","TIMER.RESEND-CODE-IN":"Puedes volver a pedir el codigo en:"}');
var i18n_eui_literals_pe_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_pe_namespaceObject, 2);
;// ./assets/i18n/eui-literals.br.json
var eui_literals_br_namespaceObject = /*#__PURE__*/JSON.parse('{"COOKIE-ACCEPTANCE.ACCEPT-ALL":"Aceitar cookies","COOKIE-ACCEPTANCE.ACCEPT-COOKIES":"Aceitar cookies","COOKIE-ACCEPTANCE.REJECT":"Recusar cookies","COOKIE-ACCEPTANCE.REJECT-ALL":"Recusar todos os cookies","COOKIE-ACCEPTANCE.AD-COOKIES-MESSAGE":"Os cookies de publicidade permitem a gestão de espaços publicitários no site. Além disso, estes cookies podem ser para publicidade personalizada e assim permitir a gestão dos espaços publicitários do site de acordo com o comportamento e hábitos de navegação do utilizador, de onde se obtém o seu perfil e permite a personalização da publicidade que é apresentada no navegador do utilizador ou noutros perfis e redes sociais do utilizador.","COOKIE-ACCEPTANCE.AD-COOKIES-TITLE":"Cookies de publicidade","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-MESSAGE":"Estes cookies permitem-nos contar visitas e fontes de circulação para medir e melhorar o desempenho da nossa plataforma.","COOKIE-ACCEPTANCE.ANALYSIS-COOKIES-TITLE":"Cookies de análise","COOKIE-ACCEPTANCE.CONFIRM-SELECTED-COOKIES":"Confirmar os cookies selecionados","COOKIE-ACCEPTANCE.CUSTOM-ACCEPTANCE":"Alterar preferências","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-MESSAGE":"Esses cookies permitem que a Plataforma ofereça melhor funcionalidade e personalização.","COOKIE-ACCEPTANCE.FUNCTIONALI-OR-PERSONALIZATION-COOKIE-TITLE":"Cookies de funcionalidade ou personalização","COOKIE-ACCEPTANCE.GENERAL-MESSAGE":"O EUROFIRMS GROUP utiliza cookies técnicos, de personalização, de análise e de publicidade, próprios e de terceiros, que processam dados de ligação e/ou dispositivo, bem como hábitos de navegação para facilitar a navegação, analisar estatísticas sobre a utilização do site e personalizar a publicidade. <a href=\'{0}\' class=\'eui-color-grey-900\' target=\'_blank\'>Saber mais</a>.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-MESSAGE":"Esses cookies são necessários para o funcionamento da Plataforma e não podem ser desativados em nossos sistemas.","COOKIE-ACCEPTANCE.STRICTLY-NECESSARY-COOKIES-TITLE":"Cookies estritamente necessários","COOKIE-ACCEPTANCE.TITLE":"Configurações de cookies","MAINTENANCE.MESSAGE":"Estamos trabalhando para melhorar o serviço. Desculpem as molestias.","MAINTENANCE.TITLE":"Estamos em manutenção","MAINTENANCE.THEME.APC.MESSAGE":"Nosso site está em manutenção. Por favor, volte mais tarde. Desculpem os transtornos.","MAINTENANCE.THEME.APC.TITLE":"Voltaremos em breve!","SECURITY-CODE.DID-NOT-GET-CODE--MAIL":"Não recebi o e-mail com o código","SECURITY-CODE.DID-NOT-GET-CODE--SMS":"Eu não refutei o SMS com o código","SECURITY-CODE.INSERT-CODE-HERE":"Insira seu código aqui:","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--MAIL":"Opa! Parece que o código não está correto, verifique o e-mail que lhe enviamos.","SECURITY-CODE.INVALID-CODE-ERROR-MESSAGE--SMS":"Opa! Parece que o código não está correto, verifique o SMS que lhe enviamos.","SECURITY-CODE.RESEND-CODE":"Reenviar","SECURITY-CODE.RESEND-CODE-IN":"Os potes voltam para solicitar o código em:","TIMER.RESEND-CODE-IN":"Você pode solicitar o código novamente em:"}');
var i18n_eui_literals_br_namespaceObject = /*#__PURE__*/__webpack_require__.t(eui_literals_br_namespaceObject, 2);
// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js
var lit_html = __webpack_require__(6752);
// EXTERNAL MODULE: ./node_modules/lit-html/directive.js
var directive = __webpack_require__(7804);
;// ./node_modules/lit-html/directives/unsafe-html.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class e extends directive/* Directive */.WL{constructor(i){if(super(i),this.et=lit_html/* nothing */.s6,i.type!==directive/* PartType */.OA.CHILD)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(r){if(r===lit_html/* nothing */.s6||null==r)return this.ft=void 0,this.et=r;if(r===lit_html/* noChange */.c0)return r;if("string"!=typeof r)throw Error(this.constructor.directiveName+"() called with a non-string value");if(r===this.et)return this.ft;this.et=r;const s=[r];return s.raw=s,this.ft={_$litType$:this.constructor.resultType,strings:s,values:[]}}}e.directiveName="unsafeHTML",e.resultType=1;const o=(0,directive/* directive */.u$)(e);
//# sourceMappingURL=unsafe-html.js.map

;// ./utils/translateService.ts











var Languages;
(function (Languages) {
    Languages["ES"] = "es";
    Languages["PT"] = "pt";
    Languages["CA"] = "ca";
    Languages["IT"] = "it";
    Languages["CL"] = "cl";
    Languages["NL"] = "nl";
    Languages["FR"] = "fr";
    Languages["EN"] = "en";
    Languages["PE"] = "pe";
    Languages["BR"] = "br";
})(Languages || (Languages = {}));
class TranslateService {
    constructor() {
        this.currentLang = Languages.ES;
    }
    setLanguage(lang) {
        if (!lang || !Languages[lang === null || lang === void 0 ? void 0 : lang.toLocaleUpperCase()])
            throw Error(`${lang} is not correct Language to set.`);
        this.currentLang = Languages[lang.toLocaleUpperCase()];
        switch (this.currentLang) {
            case Languages.EN:
                this.currentLiterals = i18n_eui_literals_en_namespaceObject;
                break;
            case Languages.NL:
                this.currentLiterals = i18n_eui_literals_nl_namespaceObject;
                break;
            case Languages.FR:
                this.currentLiterals = i18n_eui_literals_fr_namespaceObject;
                break;
            case Languages.IT:
                this.currentLiterals = i18n_eui_literals_it_namespaceObject;
                break;
            case Languages.CL:
                this.currentLiterals = i18n_eui_literals_cl_namespaceObject;
                break;
            case Languages.CA:
                this.currentLiterals = i18n_eui_literals_ca_namespaceObject;
                break;
            case Languages.PT:
                this.currentLiterals = i18n_eui_literals_pt_namespaceObject;
                break;
            case Languages.BR:
                this.currentLiterals = i18n_eui_literals_br_namespaceObject;
                break;
            case Languages.PE:
                this.currentLiterals = i18n_eui_literals_pe_namespaceObject;
                break;
            case Languages.ES:
            default:
                this.currentLiterals = i18n_eui_literals_es_namespaceObject;
                break;
        }
    }
    getLiteral(key, args) {
        if (!this.currentLiterals)
            return key;
        let literalResource = this.currentLiterals[key];
        if (literalResource && (args === null || args === void 0 ? void 0 : args.length) > 0) {
            args.map((value, i) => {
                literalResource = literalResource.replace(`{${i}}`, value);
            });
        }
        return literalResource ? literalResource : key;
    }
    getHtmlLiteral(key, args) {
        let literalResource = this.currentLiterals[key];
        if (literalResource && (args === null || args === void 0 ? void 0 : args.length) > 0) {
            args.map((value, i) => {
                literalResource = literalResource.replace(`{${i}}`, value);
            });
        }
        return literalResource ? o(literalResource) : key;
    }
}


/***/ }),

/***/ 5694:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: function() { return /* binding */ n; }
/* harmony export */ });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const i=(i,e)=>"method"===e.kind&&e.descriptor&&!("value"in e.descriptor)?{...e,finisher(n){n.createProperty(e.key,i)}}:{kind:"field",key:Symbol(),placement:"own",descriptor:{},originalKey:e.key,initializer(){"function"==typeof e.initializer&&(this[e.key]=e.initializer.call(this))},finisher(n){n.createProperty(e.key,i)}},e=(i,e,n)=>{e.constructor.createProperty(n,i)};function n(n){return(t,o)=>void 0!==o?e(n,t,o):i(n,t)}
//# sourceMappingURL=property.js.map


/***/ }),

/***/ 4290:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   w: function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _property_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5694);

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function t(t){return (0,_property_js__WEBPACK_IMPORTED_MODULE_0__/* .property */ .M)({...t,state:!0})}
//# sourceMappingURL=state.js.map


/***/ }),

/***/ 7804:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OA: function() { return /* binding */ t; },
/* harmony export */   WL: function() { return /* binding */ i; },
/* harmony export */   u$: function() { return /* binding */ e; }
/* harmony export */ });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},e=t=>(...e)=>({_$litDirective$:t,values:e});class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}}
//# sourceMappingURL=directive.js.map


/***/ }),

/***/ 6752:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   XX: function() { return /* binding */ D; },
/* harmony export */   c0: function() { return /* binding */ T; },
/* harmony export */   qy: function() { return /* binding */ x; },
/* harmony export */   s6: function() { return /* binding */ A; }
/* harmony export */ });
/* unused harmony exports _$LH, svg */
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t;const i=window,s=i.trustedTypes,e=s?s.createPolicy("lit-html",{createHTML:t=>t}):void 0,o="$lit$",n=`lit$${(Math.random()+"").slice(9)}$`,l="?"+n,h=`<${l}>`,r=document,u=()=>r.createComment(""),d=t=>null===t||"object"!=typeof t&&"function"!=typeof t,c=Array.isArray,v=t=>c(t)||"function"==typeof(null==t?void 0:t[Symbol.iterator]),a="[ \t\n\f\r]",f=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_=/-->/g,m=/>/g,p=RegExp(`>|${a}(?:([^\\s"'>=/]+)(${a}*=${a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g=/'/g,$=/"/g,y=/^(?:script|style|textarea|title)$/i,w=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),x=w(1),b=w(2),T=Symbol.for("lit-noChange"),A=Symbol.for("lit-nothing"),E=new WeakMap,C=r.createTreeWalker(r,129,null,!1);function P(t,i){if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==e?e.createHTML(i):i}const V=(t,i)=>{const s=t.length-1,e=[];let l,r=2===i?"<svg>":"",u=f;for(let i=0;i<s;i++){const s=t[i];let d,c,v=-1,a=0;for(;a<s.length&&(u.lastIndex=a,c=u.exec(s),null!==c);)a=u.lastIndex,u===f?"!--"===c[1]?u=_:void 0!==c[1]?u=m:void 0!==c[2]?(y.test(c[2])&&(l=RegExp("</"+c[2],"g")),u=p):void 0!==c[3]&&(u=p):u===p?">"===c[0]?(u=null!=l?l:f,v=-1):void 0===c[1]?v=-2:(v=u.lastIndex-c[2].length,d=c[1],u=void 0===c[3]?p:'"'===c[3]?$:g):u===$||u===g?u=p:u===_||u===m?u=f:(u=p,l=void 0);const w=u===p&&t[i+1].startsWith("/>")?" ":"";r+=u===f?s+h:v>=0?(e.push(d),s.slice(0,v)+o+s.slice(v)+n+w):s+n+(-2===v?(e.push(void 0),i):w)}return[P(t,r+(t[s]||"<?>")+(2===i?"</svg>":"")),e]};class N{constructor({strings:t,_$litType$:i},e){let h;this.parts=[];let r=0,d=0;const c=t.length-1,v=this.parts,[a,f]=V(t,i);if(this.el=N.createElement(a,e),C.currentNode=this.el.content,2===i){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes)}for(;null!==(h=C.nextNode())&&v.length<c;){if(1===h.nodeType){if(h.hasAttributes()){const t=[];for(const i of h.getAttributeNames())if(i.endsWith(o)||i.startsWith(n)){const s=f[d++];if(t.push(i),void 0!==s){const t=h.getAttribute(s.toLowerCase()+o).split(n),i=/([.?@])?(.*)/.exec(s);v.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?H:"?"===i[1]?L:"@"===i[1]?z:k})}else v.push({type:6,index:r})}for(const i of t)h.removeAttribute(i)}if(y.test(h.tagName)){const t=h.textContent.split(n),i=t.length-1;if(i>0){h.textContent=s?s.emptyScript:"";for(let s=0;s<i;s++)h.append(t[s],u()),C.nextNode(),v.push({type:2,index:++r});h.append(t[i],u())}}}else if(8===h.nodeType)if(h.data===l)v.push({type:2,index:r});else{let t=-1;for(;-1!==(t=h.data.indexOf(n,t+1));)v.push({type:7,index:r}),t+=n.length-1}r++}}static createElement(t,i){const s=r.createElement("template");return s.innerHTML=t,s}}function S(t,i,s=t,e){var o,n,l,h;if(i===T)return i;let r=void 0!==e?null===(o=s._$Co)||void 0===o?void 0:o[e]:s._$Cl;const u=d(i)?void 0:i._$litDirective$;return(null==r?void 0:r.constructor)!==u&&(null===(n=null==r?void 0:r._$AO)||void 0===n||n.call(r,!1),void 0===u?r=void 0:(r=new u(t),r._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Co)&&void 0!==l?l:h._$Co=[])[e]=r:s._$Cl=r),void 0!==r&&(i=S(t,r._$AS(t,i.values),r,e)),i}class M{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:r).importNode(s,!0);C.currentNode=o;let n=C.nextNode(),l=0,h=0,u=e[0];for(;void 0!==u;){if(l===u.index){let i;2===u.type?i=new R(n,n.nextSibling,this,t):1===u.type?i=new u.ctor(n,u.name,u.strings,this,t):6===u.type&&(i=new Z(n,this,t)),this._$AV.push(i),u=e[++h]}l!==(null==u?void 0:u.index)&&(n=C.nextNode(),l++)}return C.currentNode=r,o}v(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++}}class R{constructor(t,i,s,e){var o;this.type=2,this._$AH=A,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cp=null===(o=null==e?void 0:e.isConnected)||void 0===o||o}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cp}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===(null==t?void 0:t.nodeType)&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=S(this,t,i),d(t)?t===A||null==t||""===t?(this._$AH!==A&&this._$AR(),this._$AH=A):t!==this._$AH&&t!==T&&this._(t):void 0!==t._$litType$?this.g(t):void 0!==t.nodeType?this.$(t):v(t)?this.T(t):this._(t)}k(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}$(t){this._$AH!==t&&(this._$AR(),this._$AH=this.k(t))}_(t){this._$AH!==A&&d(this._$AH)?this._$AA.nextSibling.data=t:this.$(r.createTextNode(t)),this._$AH=t}g(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=N.createElement(P(e.h,e.h[0]),this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.v(s);else{const t=new M(o,this),i=t.u(this.options);t.v(s),this.$(i),this._$AH=t}}_$AC(t){let i=E.get(t.strings);return void 0===i&&E.set(t.strings,i=new N(t)),i}T(t){c(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new R(this.k(u()),this.k(u()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e)}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i}}setConnected(t){var i;void 0===this._$AM&&(this._$Cp=t,null===(i=this._$AP)||void 0===i||i.call(this,t))}}class k{constructor(t,i,s,e,o){this.type=1,this._$AH=A,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=S(this,t,i,0),n=!d(t)||t!==this._$AH&&t!==T,n&&(this._$AH=t);else{const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=S(this,e[s+l],i,l),h===T&&(h=this._$AH[l]),n||(n=!d(h)||h!==this._$AH[l]),h===A?t=A:t!==A&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h}n&&!e&&this.j(t)}j(t){t===A?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"")}}class H extends k{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===A?void 0:t}}const I=s?s.emptyScript:"";class L extends k{constructor(){super(...arguments),this.type=4}j(t){t&&t!==A?this.element.setAttribute(this.name,I):this.element.removeAttribute(this.name)}}class z extends k{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5}_$AI(t,i=this){var s;if((t=null!==(s=S(this,t,i,0))&&void 0!==s?s:A)===T)return;const e=this._$AH,o=t===A&&e!==A||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==A&&(e===A||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t)}}class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s}get _$AU(){return this._$AM._$AU}_$AI(t){S(this,t)}}const j={O:o,P:n,A:l,C:1,M:V,L:M,R:v,D:S,I:R,V:k,H:L,N:z,U:H,F:Z},B=i.litHtmlPolyfillSupport;null==B||B(N,R),(null!==(t=i.litHtmlVersions)&&void 0!==t?t:i.litHtmlVersions=[]).push("2.8.0");const D=(t,i,s)=>{var e,o;const n=null!==(e=null==s?void 0:s.renderBefore)&&void 0!==e?e:i;let l=n._$litPart$;if(void 0===l){const t=null!==(o=null==s?void 0:s.renderBefore)&&void 0!==o?o:null;n._$litPart$=l=new R(i.insertBefore(u(),t),t,void 0,null!=s?s:{})}return l._$AI(t),l};
//# sourceMappingURL=lit-html.js.map


/***/ }),

/***/ 9204:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  EM: function() { return /* reexport */ custom_element_e; },
  MZ: function() { return /* reexport */ property/* property */.M; },
  wk: function() { return /* reexport */ state/* state */.w; }
});

// UNUSED EXPORTS: eventOptions, query, queryAll, queryAssignedElements, queryAssignedNodes, queryAsync

;// ./node_modules/@lit/reactive-element/decorators/custom-element.js
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const custom_element_e=e=>n=>"function"==typeof n?((e,n)=>(customElements.define(e,n),n))(e,n):((e,n)=>{const{kind:t,elements:s}=n;return{kind:t,elements:s,finisher(n){customElements.define(e,n)}}})(e,n);
//# sourceMappingURL=custom-element.js.map

// EXTERNAL MODULE: ./node_modules/@lit/reactive-element/decorators/property.js
var property = __webpack_require__(5694);
// EXTERNAL MODULE: ./node_modules/@lit/reactive-element/decorators/state.js
var state = __webpack_require__(4290);
;// ./node_modules/@lit/reactive-element/decorators/query-assigned-elements.js

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var n;const query_assigned_elements_e=null!=(null===(n=window.HTMLSlotElement)||void 0===n?void 0:n.prototype.assignedElements)?(o,n)=>o.assignedElements(n):(o,n)=>o.assignedNodes(n).filter((o=>o.nodeType===Node.ELEMENT_NODE));function l(n){const{slot:l,selector:t}=null!=n?n:{};return o({descriptor:o=>({get(){var o;const r="slot"+(l?`[name=${l}]`:":not([name])"),i=null===(o=this.renderRoot)||void 0===o?void 0:o.querySelector(r),s=null!=i?query_assigned_elements_e(i,n):[];return t?s.filter((o=>o.matches(t))):s},enumerable:!0,configurable:!0})})}
//# sourceMappingURL=query-assigned-elements.js.map

;// ./node_modules/@lit/reactive-element/decorators/query-assigned-nodes.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function query_assigned_nodes_o(o,n,r){let l,s=o;return"object"==typeof o?(s=o.slot,l=o):l={flatten:n},r?t({slot:s,flatten:n,selector:r}):e({descriptor:e=>({get(){var e,t;const o="slot"+(s?`[name=${s}]`:":not([name])"),n=null===(e=this.renderRoot)||void 0===e?void 0:e.querySelector(o);return null!==(t=null==n?void 0:n.assignedNodes(l))&&void 0!==t?t:[]},enumerable:!0,configurable:!0})})}
//# sourceMappingURL=query-assigned-nodes.js.map

;// ./node_modules/lit/decorators.js

//# sourceMappingURL=decorators.js.map


/***/ }),

/***/ 6684:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  WF: function() { return /* reexport */ lit_element_s; },
  AH: function() { return /* reexport */ i; },
  qy: function() { return /* reexport */ lit_html/* html */.qy; }
});

// UNUSED EXPORTS: CSSResult, ReactiveElement, UpdatingElement, _$LE, _$LH, adoptStyles, defaultConverter, getCompatibleStyle, isServer, noChange, notEqual, nothing, render, supportsAdoptingStyleSheets, svg, unsafeCSS

;// ./node_modules/@lit/reactive-element/css-tag.js
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const css_tag_t=window,e=css_tag_t.ShadowRoot&&(void 0===css_tag_t.ShadyCSS||css_tag_t.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s=Symbol(),n=new WeakMap;class o{constructor(t,e,n){if(this._$cssResult$=!0,n!==s)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o;const s=this.t;if(e&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=n.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&n.set(s,t))}return t}toString(){return this.cssText}}const r=t=>new o("string"==typeof t?t:t+"",void 0,s),i=(t,...e)=>{const n=1===t.length?t[0]:e.reduce(((e,s,n)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[n+1]),t[0]);return new o(n,t,s)},S=(s,n)=>{e?s.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((e=>{const n=document.createElement("style"),o=css_tag_t.litNonce;void 0!==o&&n.setAttribute("nonce",o),n.textContent=e.cssText,s.appendChild(n)}))},c=e?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r(e)})(t):t;
//# sourceMappingURL=css-tag.js.map

;// ./node_modules/@lit/reactive-element/reactive-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var reactive_element_s;const reactive_element_e=window,reactive_element_r=reactive_element_e.trustedTypes,h=reactive_element_r?reactive_element_r.emptyScript:"",reactive_element_o=reactive_element_e.reactiveElementPolyfillSupport,reactive_element_n={toAttribute(t,i){switch(i){case Boolean:t=t?h:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t)}catch(t){s=null}}return s}},a=(t,i)=>i!==t&&(i==i||t==t),l={attribute:!0,type:String,converter:reactive_element_n,reflect:!1,hasChanged:a},d="finalized";class u extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this._$Eu()}static addInitializer(t){var i;this.finalize(),(null!==(i=this.h)&&void 0!==i?i:this.h=[]).push(t)}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Ep(s,i);void 0!==e&&(this._$Ev.set(e,s),t.push(e))})),t}static createProperty(t,i=l){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e)}}static getPropertyDescriptor(t,i,s){return{get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l}static finalize(){if(this.hasOwnProperty(d))return!1;this[d]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s])}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(c(i))}else void 0!==i&&s.push(c(i));return s}static _$Ep(t,i){const s=i.attribute;return!1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}_$Eu(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)))}addController(t){var i,s;(null!==(i=this._$ES)&&void 0!==i?i:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t))}removeController(t){var i;null===(i=this._$ES)||void 0===i||i.splice(this._$ES.indexOf(t)>>>0,1)}_$Eg(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Ei.set(i,this[i]),delete this[i])}))}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}))}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}))}attributeChangedCallback(t,i,s){this._$AK(t,s)}_$EO(t,i,s=l){var e;const r=this.constructor._$Ep(t,s);if(void 0!==r&&!0===s.reflect){const h=(void 0!==(null===(e=s.converter)||void 0===e?void 0:e.toAttribute)?s.converter:reactive_element_n).toAttribute(i,s.type);this._$El=t,null==h?this.removeAttribute(r):this.setAttribute(r,h),this._$El=null}}_$AK(t,i){var s;const e=this.constructor,r=e._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=e.getPropertyOptions(r),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(s=t.converter)||void 0===s?void 0:s.fromAttribute)?t.converter:reactive_element_n;this._$El=r,this[r]=h.fromAttribute(i,t.type),this._$El=null}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||a)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$E_=this._$Ej())}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,i)=>this[i]=t)),this._$Ei=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$Ek()}catch(t){throw i=!1,this._$Ek(),t}i&&this._$AE(s)}willUpdate(t){}_$AE(t){var i;null===(i=this._$ES)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return!0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$EO(i,this[i],t))),this._$EC=void 0),this._$Ek()}updated(t){}firstUpdated(t){}}u[d]=!0,u.elementProperties=new Map,u.elementStyles=[],u.shadowRootOptions={mode:"open"},null==reactive_element_o||reactive_element_o({ReactiveElement:u}),(null!==(reactive_element_s=reactive_element_e.reactiveElementVersions)&&void 0!==reactive_element_s?reactive_element_s:reactive_element_e.reactiveElementVersions=[]).push("1.6.3");
//# sourceMappingURL=reactive-element.js.map

// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js
var lit_html = __webpack_require__(6752);
;// ./node_modules/lit-element/lit-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var lit_element_l,lit_element_o;const lit_element_r=(/* unused pure expression or super */ null && (t));class lit_element_s extends u{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=(0,lit_html/* render */.XX)(i,this.renderRoot,this.renderOptions)}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!0)}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!1)}render(){return lit_html/* noChange */.c0}}lit_element_s.finalized=!0,lit_element_s._$litElement$=!0,null===(lit_element_l=globalThis.litElementHydrateSupport)||void 0===lit_element_l||lit_element_l.call(globalThis,{LitElement:lit_element_s});const lit_element_n=globalThis.litElementPolyfillSupport;null==lit_element_n||lit_element_n({LitElement:lit_element_s});const lit_element_h={_$AK:(t,e,i)=>{t._$AK(e,i)},_$AL:t=>t._$AL};(null!==(lit_element_o=globalThis.litElementVersions)&&void 0!==lit_element_o?lit_element_o:globalThis.litElementVersions=[]).push("3.3.3");
//# sourceMappingURL=lit-element.js.map

;// ./node_modules/lit/index.js

//# sourceMappingURL=index.js.map


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	!function() {
/******/ 		var getProto = Object.getPrototypeOf ? function(obj) { return Object.getPrototypeOf(obj); } : function(obj) { return obj.__proto__; };
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach(function(key) { def[key] = function() { return value[key]; }; });
/******/ 			}
/******/ 			def['default'] = function() { return value; };
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// UNUSED EXPORTS: EuiCookieAcceptanceManager

// EXTERNAL MODULE: ./node_modules/lit/index.js + 3 modules
var lit = __webpack_require__(6684);
// EXTERNAL MODULE: ./node_modules/lit/decorators.js + 3 modules
var decorators = __webpack_require__(9204);
;// ./node_modules/@firebase/util/dist/index.esm2017.js
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw new DecodeBase64StringError();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (const prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
    if (typeof process === 'undefined' || "string" === 'undefined') {
        return;
    }
    const defaultsJsonString = "MISSING_ENV_VAR".__FIREBASE_DEFAULTS__;
    if (defaultsJsonString) {
        return JSON.parse(defaultsJsonString);
    }
};
const getDefaultsFromCookie = () => {
    if (typeof document === 'undefined') {
        return;
    }
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    }
    catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
    try {
        return (getDefaultsFromGlobal() ||
            getDefaultsFromEnvVariable() ||
            getDefaultsFromCookie());
    }
    catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */
const getDefaultEmulatorHost = (productName) => { var _a, _b; return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName]; };
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */
const getDefaultEmulatorHostnameAndPort = (productName) => {
    const host = getDefaultEmulatorHost(productName);
    if (!host) {
        return undefined;
    }
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
        throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    }
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') {
        // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
        return [host.substring(1, separatorIndex - 1), port];
    }
    else {
        return [host.substring(0, separatorIndex), port];
    }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const getDefaultAppConfig = () => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config; };
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */
const getExperimentalSetting = (name) => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`]; };

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    const payload = Object.assign({ 
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`, aud: project, iat, exp: iat + 3600, auth_time: iat, sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') {
        return true;
    }
    else if (forceEnvironment === 'browser') {
        return false;
    }
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */
function index_esm2017_isBrowser() {
    return typeof window !== 'undefined' || index_esm2017_isWebWorker();
}
/**
 * Detect Web Worker context.
 */
function index_esm2017_isWebWorker() {
    return (typeof WorkerGlobalScope !== 'undefined' &&
        typeof self !== 'undefined' &&
        self instanceof WorkerGlobalScope);
}
/**
 * Detect Cloudflare Worker context.
 */
function isCloudflareWorker() {
    return (typeof navigator !== 'undefined' &&
        navigator.userAgent === 'Cloudflare-Workers');
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        !!navigator.userAgent &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function index_esm2017_isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    }
    catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function index_esm2017_validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */
function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(() => deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams)) {
        if (Array.isArray(value)) {
            value.forEach(arrayVal => {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(token => {
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
    constructor() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (let i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    compress_(buf, offset) {
        if (!offset) {
            offset = 0;
        }
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (let i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (let i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (let i = 16; i < 80; i++) {
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (let i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            const t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */
    digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (let i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for (let i = 0; i < 5; i++) {
            for (let j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    constructor(executor, onNoObservers) {
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(() => {
            executor(this);
        })
            .catch(e => {
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer) => {
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer) => {
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer) => {
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */
    subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error,
                complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(() => {
                try {
                    if (this.finalError) {
                        observer.error(this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    }
    forEachObserver(fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (let i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            if (this.observers !== undefined && this.observers[i] !== undefined) {
                try {
                    fn(this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    }
    close(err) {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function index_esm2017_async(fn, onError) {
    return (...args) => {
        Promise.resolve(true)
            .then(() => {
            fn(...args);
        })
            .catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const method of methods) {
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        const error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */
const uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return `${i}`;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    const dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_esm2017_getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// ./node_modules/@firebase/component/dist/esm/index.esm2017.js


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class index_esm2017_ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var index_esm2017_LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(index_esm2017_LogLevel || (index_esm2017_LogLevel = {}));
const levelStringToEnum = {
    'debug': index_esm2017_LogLevel.DEBUG,
    'verbose': index_esm2017_LogLevel.VERBOSE,
    'info': index_esm2017_LogLevel.INFO,
    'warn': index_esm2017_LogLevel.WARN,
    'error': index_esm2017_LogLevel.ERROR,
    'silent': index_esm2017_LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = index_esm2017_LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [index_esm2017_LogLevel.DEBUG]: 'log',
    [index_esm2017_LogLevel.VERBOSE]: 'log',
    [index_esm2017_LogLevel.INFO]: 'info',
    [index_esm2017_LogLevel.WARN]: 'warn',
    [index_esm2017_LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in index_esm2017_LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, index_esm2017_LogLevel.DEBUG, ...args);
        this._logHandler(this, index_esm2017_LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, index_esm2017_LogLevel.VERBOSE, ...args);
        this._logHandler(this, index_esm2017_LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, index_esm2017_LogLevel.INFO, ...args);
        this._logHandler(this, index_esm2017_LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, index_esm2017_LogLevel.WARN, ...args);
        this._logHandler(this, index_esm2017_LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, index_esm2017_LogLevel.ERROR, ...args);
        this._logHandler(this, index_esm2017_LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach(inst => {
        inst.setLogLevel(level);
    });
}
function index_esm2017_setUserLogHandler(logCallback, options) {
    for (const instance of instances) {
        let customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = (instance, level, ...args) => {
                const message = args
                    .map(arg => {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(arg => arg)
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: index_esm2017_LogLevel[level].toLowerCase(),
                        message,
                        args,
                        type: instance.name
                    });
                }
            };
        }
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// ./node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap_idb_value_wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap_idb_value_wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap_idb_value_wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap_idb_value_wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap_idb_value_wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap_idb_value_wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// ./node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap_idb_value_wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap_idb_value_wrap(request.result), event.oldVersion, event.newVersion, wrap_idb_value_wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



;// ./node_modules/@firebase/app/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}

const name$q = "@firebase/app";
const version$1 = "0.10.15";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger('@firebase/app');

const name$p = "@firebase/app-compat";

const name$o = "@firebase/analytics-compat";

const name$n = "@firebase/analytics";

const name$m = "@firebase/app-check-compat";

const name$l = "@firebase/app-check";

const name$k = "@firebase/auth";

const name$j = "@firebase/auth-compat";

const name$i = "@firebase/database";

const name$h = "@firebase/data-connect";

const name$g = "@firebase/database-compat";

const name$f = "@firebase/functions";

const name$e = "@firebase/functions-compat";

const name$d = "@firebase/installations";

const name$c = "@firebase/installations-compat";

const name$b = "@firebase/messaging";

const name$a = "@firebase/messaging-compat";

const name$9 = "@firebase/performance";

const name$8 = "@firebase/performance-compat";

const name$7 = "@firebase/remote-config";

const name$6 = "@firebase/remote-config-compat";

const name$5 = "@firebase/storage";

const name$4 = "@firebase/storage-compat";

const name$3 = "@firebase/firestore";

const name$2 = "@firebase/vertexai";

const name$1 = "@firebase/firestore-compat";

const index_esm2017_name = "firebase";
const version = "11.0.1";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const index_esm2017_DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$q]: 'fire-core',
    [name$p]: 'fire-core-compat',
    [name$n]: 'fire-analytics',
    [name$o]: 'fire-analytics-compat',
    [name$l]: 'fire-app-check',
    [name$m]: 'fire-app-check-compat',
    [name$k]: 'fire-auth',
    [name$j]: 'fire-auth-compat',
    [name$i]: 'fire-rtdb',
    [name$h]: 'fire-data-connect',
    [name$g]: 'fire-rtdb-compat',
    [name$f]: 'fire-fn',
    [name$e]: 'fire-fn-compat',
    [name$d]: 'fire-iid',
    [name$c]: 'fire-iid-compat',
    [name$b]: 'fire-fcm',
    [name$a]: 'fire-fcm-compat',
    [name$9]: 'fire-perf',
    [name$8]: 'fire-perf-compat',
    [name$7]: 'fire-rc',
    [name$6]: 'fire-rc-compat',
    [name$5]: 'fire-gcs',
    [name$4]: 'fire-gcs-compat',
    [name$3]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    [name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [index_esm2017_name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * @internal
 */
const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    for (const serverApp of _serverApps.values()) {
        _addComponent(serverApp, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function index_esm2017_getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
    index_esm2017_getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */
function _isFirebaseApp(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */
function _isFirebaseServerApp(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call initializeApp() first',
    ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new Component('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */, { appName: this._name });
        }
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseServerAppImpl extends FirebaseAppImpl {
    constructor(options, serverConfig, name, container) {
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined
            ? serverConfig.automaticDataCollectionEnabled
            : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name,
            automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) {
            // Construct the parent FirebaseAppImp object.
            super(options, config, container);
        }
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({ automaticDataCollectionEnabled }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') {
            this._finalizationRegistry = new FinalizationRegistry(() => {
                this.automaticCleanup();
            });
        }
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        registerVersion(name$q, version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) {
            return;
        }
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) {
            this._finalizationRegistry.register(obj, this);
        }
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) {
            return 0;
        }
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        void deleteApp(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */);
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: index_esm2017_DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    options || (options = getDefaultAppConfig());
    if (!options) {
        throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */);
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (deepEqual(options, existingApp.options) &&
            deepEqual(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new index_esm2017_ComponentContainer(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
function initializeServerApp(_options, _serverAppConfig) {
    if (isBrowser() && !isWebWorker()) {
        // FirebaseServerApp isn't designed to be run in browsers.
        throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */);
    }
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) {
        _serverAppConfig.automaticDataCollectionEnabled = false;
    }
    let appOptions;
    if (_isFirebaseApp(_options)) {
        appOptions = _options.options;
    }
    else {
        appOptions = _options;
    }
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) {
        delete nameObj.releaseOnDeref;
    }
    const hashCode = (s) => {
        return [...s].reduce((hash, c) => (Math.imul(31, hash) + c.charCodeAt(0)) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') {
            throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */, {});
        }
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = _serverApps.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new ComponentContainer(nameString);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    _serverApps.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function index_esm2017_getApp(name = index_esm2017_DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === index_esm2017_DEFAULT_ENTRY_NAME && getDefaultAppConfig()) {
        return initializeApp();
    }
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
    let cleanupProviders = false;
    const name = app.name;
    if (_apps.has(name)) {
        cleanupProviders = true;
        _apps.delete(name);
    }
    else if (_serverApps.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            _serverApps.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container
            .getProviders()
            .map(provider => provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new Component(`${library}-version`, () => ({ library, version }), "VERSION" /* ComponentType.VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */);
    }
    setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function index_esm2017_setLogLevel(logLevel) {
    setLogLevel$1(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        try {
                            db.createObjectStore(STORE_NAME);
                        }
                        catch (e) {
                            // Safari/iOS browsers throw occasional exceptions on
                            // db.createObjectStore() that may be a bug. Avoid blocking
                            // the rest of the app functionality.
                            console.warn(e);
                        }
                }
            }
        }).catch(e => {
            throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    }
    catch (e) {
        if (e instanceof FirebaseError) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    }
    catch (e) {
        if (e instanceof FirebaseError) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container
                .getProvider('platform-logger')
                .getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) {
                    return;
                }
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
                this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
                return;
            }
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({ date, agent });
            }
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats =
                this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
                    const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                    const now = Date.now();
                    return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                });
            return this._storage.overwrite(this._heartbeatsCache);
        }
        catch (e) {
            logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) {
                await this._heartbeatsCachePromise;
            }
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null ||
                this._heartbeatsCache.heartbeats.length === 0) {
                return '';
            }
            const date = getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = base64urlEncodeWithoutPadding(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            }
            else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                void this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        }
        catch (e) {
            logger.warn(e);
            return '';
        }
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!index_esm2017_isIndexedDBAvailable()) {
            return false;
        }
        else {
            return index_esm2017_validateIndexedDBOpenable()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) {
                return idbHeartbeatObject;
            }
            else {
                return { heartbeats: [] };
            }
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return base64urlEncodeWithoutPadding(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new Component('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    _registerComponent(new Component('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    // Register `app` package.
    registerVersion(name$q, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    registerVersion(name$q, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');


//# sourceMappingURL=index.esm2017.js.map

;// ./node_modules/firebase/app/dist/esm/index.esm.js



var index_esm_name = "firebase";
var index_esm_version = "11.0.1";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerVersion(index_esm_name, index_esm_version, 'app');
//# sourceMappingURL=index.esm.js.map

;// ./node_modules/@firebase/installations/dist/esm/index.esm2017.js





const esm_index_esm2017_name = "@firebase/installations";
const index_esm2017_version = "0.6.10";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${index_esm2017_version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */]: "Can't delete installation while there is a pending registration request."
};
const index_esm2017_ERROR_FACTORY = new ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof FirebaseError &&
        error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return index_esm2017_ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */, {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) {
        // Internal Server Error. Retry request.
        return fn();
    }
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    }
    else {
        throw await getErrorFromResponse('Create Installation', response);
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 0b01110000 + (fidByteArray[0] % 0b00010000);
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    const key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    const key = getKey(appConfig);
    let callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    const key = getKey(appConfig);
    const callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    for (const callback of callbacks) {
        callback(fid);
    }
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key, fid });
    }
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = e => {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let index_esm2017_dbPromise = null;
function index_esm2017_getDbPromise() {
    if (!index_esm2017_dbPromise) {
        index_esm2017_dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(OBJECT_STORE_NAME);
                }
            }
        });
    }
    return index_esm2017_dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
async function set(appConfig, value) {
    const key = getKey(appConfig);
    const db = await index_esm2017_getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await objectStore.get(key));
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) {
        fidChanged(appConfig, value.fid);
    }
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */
async function remove(appConfig) {
    const key = getKey(appConfig);
    const db = await index_esm2017_getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
async function update(appConfig, updateFn) {
    const key = getKey(appConfig);
    const db = await index_esm2017_getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await store.get(key));
    const newValue = updateFn(oldValue);
    if (newValue === undefined) {
        await store.delete(key);
    }
    else {
        await store.put(newValue, key);
    }
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
        fidChanged(appConfig, newValue.fid);
    }
    return newValue;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, oldEntry => {
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) {
        // FID generation failed. Waiting for the FID from the server.
        return { installationEntry: await registrationPromise };
    }
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        return {
            installationEntry,
            registrationPromise: waitUntilFidRegistration(installations)
        };
    }
    else {
        return { installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    }
    catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) {
            // Server returned a "FID cannot be used" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            // Registration failed. Set FID as not registered.
            await set(installations.appConfig, {
                fid: installationEntry.fid,
                registrationStatus: 0 /* RequestStatus.NOT_STARTED */
            });
        }
        throw e;
    }
}
/** Call if FID registration is pending in another request. */
async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) {
            return registrationPromise;
        }
        else {
            // if there is no registrationPromise, entry is registered.
            return installationEntry;
        }
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!oldEntry) {
            throw index_esm2017_ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    }
    else {
        throw await getErrorFromResponse('Generate Auth Token', response);
    }
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw index_esm2017_ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
            // There is a valid token in the DB.
            return oldEntry;
        }
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        }
        else {
            // No token or token expired.
            if (!navigator.onLine) {
                throw index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise
        ? await tokenPromise
        : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while (entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        return refreshAuthToken(installations, forceRefresh);
    }
    else {
        return authToken;
    }
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw index_esm2017_ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object.assign(Object.assign({}, oldEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken });
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    }
    catch (e) {
        if (isServerError(e) &&
            (e.customData.serverCode === 401 || e.customData.serverCode === 404)) {
            // Server returned a "FID not found" or a "Invalid authentication" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* RequestStatus.COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) {
        registrationPromise.catch(console.error);
    }
    else {
        // If the installation is already registered, update the authentication
        // token if needed.
        refreshAuthToken(installationsImpl).catch(console.error);
    }
    return installationEntry.fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getToken(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) {
        // A createInstallation request is in progress. Wait until it finishes.
        await registrationPromise;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = getDeleteEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (!response.ok) {
        throw await getErrorFromResponse('Delete Installation', response);
    }
}
function getDeleteEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function deleteInstallations(installations) {
    const { appConfig } = installations;
    const entry = await update(appConfig, oldEntry => {
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
            // Delete the unregistered entry without sending a deleteInstallation request.
            return undefined;
        }
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // Can't delete while trying to register.
            throw index_esm2017_ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */);
        }
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */) {
            if (!navigator.onLine) {
                throw index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            else {
                await deleteInstallationRequest(appConfig, entry);
                await remove(appConfig);
            }
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */
function onIdChange(installations, callback) {
    const { appConfig } = installations;
    addCallback(appConfig, callback);
    return () => {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */
function getInstallations(app = getApp()) {
    const installationsImpl = _getProvider(app, 'installations').getImmediate();
    return installationsImpl;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys) {
        if (!app.options[keyName]) {
            throw getMissingValueError(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return index_esm2017_ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig(app);
    const heartbeatServiceProvider = index_esm2017_getProvider(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: () => Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = index_esm2017_getProvider(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: () => getId(installations),
        getToken: (forceRefresh) => getToken(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    _registerComponent(new Component(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    _registerComponent(new Component(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
}

/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
registerInstallations();
registerVersion(esm_index_esm2017_name, index_esm2017_version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
registerVersion(esm_index_esm2017_name, index_esm2017_version, 'esm2017');


//# sourceMappingURL=index.esm2017.js.map

;// ./node_modules/@firebase/remote-config/dist/esm/index.esm2017.js






const dist_esm_index_esm2017_name = "@firebase/remote-config";
const esm_index_esm2017_version = "0.4.10";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Shims a minimal AbortSignal.
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */
class RemoteConfigAbortSignal {
    constructor() {
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach(listener => listener());
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const RC_COMPONENT_NAME = 'remote-config';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_ERROR_DESCRIPTION_MAP = {
    ["registration-window" /* ErrorCode.REGISTRATION_WINDOW */]: 'Undefined window object. This SDK only supports usage in a browser environment.',
    ["registration-project-id" /* ErrorCode.REGISTRATION_PROJECT_ID */]: 'Undefined project identifier. Check Firebase app initialization.',
    ["registration-api-key" /* ErrorCode.REGISTRATION_API_KEY */]: 'Undefined API key. Check Firebase app initialization.',
    ["registration-app-id" /* ErrorCode.REGISTRATION_APP_ID */]: 'Undefined app identifier. Check Firebase app initialization.',
    ["storage-open" /* ErrorCode.STORAGE_OPEN */]: 'Error thrown when opening storage. Original error: {$originalErrorMessage}.',
    ["storage-get" /* ErrorCode.STORAGE_GET */]: 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.',
    ["storage-set" /* ErrorCode.STORAGE_SET */]: 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.',
    ["storage-delete" /* ErrorCode.STORAGE_DELETE */]: 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.',
    ["fetch-client-network" /* ErrorCode.FETCH_NETWORK */]: 'Fetch client failed to connect to a network. Check Internet connection.' +
        ' Original error: {$originalErrorMessage}.',
    ["fetch-timeout" /* ErrorCode.FETCH_TIMEOUT */]: 'The config fetch request timed out. ' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.',
    ["fetch-throttle" /* ErrorCode.FETCH_THROTTLE */]: 'The config fetch request timed out while in an exponential backoff state.' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.' +
        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
    ["fetch-client-parse" /* ErrorCode.FETCH_PARSE */]: 'Fetch client could not parse response.' +
        ' Original error: {$originalErrorMessage}.',
    ["fetch-status" /* ErrorCode.FETCH_STATUS */]: 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.',
    ["indexed-db-unavailable" /* ErrorCode.INDEXED_DB_UNAVAILABLE */]: 'Indexed DB is not supported by current browser'
};
const esm_index_esm2017_ERROR_FACTORY = new ErrorFactory('remoteconfig' /* service */, 'Remote Config' /* service name */, index_esm2017_ERROR_DESCRIPTION_MAP);
// Note how this is like typeof/instanceof, but for ErrorCode.
function hasErrorCode(e, errorCode) {
    return e instanceof FirebaseError && e.code.indexOf(errorCode) !== -1;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_VALUE_FOR_BOOLEAN = false;
const DEFAULT_VALUE_FOR_STRING = '';
const DEFAULT_VALUE_FOR_NUMBER = 0;
const BOOLEAN_TRUTHY_VALUES = ['1', 'true', 't', 'yes', 'y', 'on'];
class Value {
    constructor(_source, _value = DEFAULT_VALUE_FOR_STRING) {
        this._source = _source;
        this._value = _value;
    }
    asString() {
        return this._value;
    }
    asBoolean() {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_BOOLEAN;
        }
        return BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
    }
    asNumber() {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_NUMBER;
        }
        let num = Number(this._value);
        if (isNaN(num)) {
            num = DEFAULT_VALUE_FOR_NUMBER;
        }
        return num;
    }
    getSource() {
        return this._source;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 * @returns A {@link RemoteConfig} instance.
 *
 * @public
 */
function getRemoteConfig(app = index_esm2017_getApp()) {
    app = index_esm2017_getModularInstance(app);
    const rcProvider = index_esm2017_getProvider(app, RC_COMPONENT_NAME);
    return rcProvider.getImmediate();
}
/**
 * Makes the last fetched config available to the getters.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @returns A `Promise` which resolves to true if the current call activated the fetched configs.
 * If the fetched configs were already activated, the `Promise` will resolve to false.
 *
 * @public
 */
async function activate(remoteConfig) {
    const rc = index_esm2017_getModularInstance(remoteConfig);
    const [lastSuccessfulFetchResponse, activeConfigEtag] = await Promise.all([
        rc._storage.getLastSuccessfulFetchResponse(),
        rc._storage.getActiveConfigEtag()
    ]);
    if (!lastSuccessfulFetchResponse ||
        !lastSuccessfulFetchResponse.config ||
        !lastSuccessfulFetchResponse.eTag ||
        lastSuccessfulFetchResponse.eTag === activeConfigEtag) {
        // Either there is no successful fetched config, or is the same as current active
        // config.
        return false;
    }
    await Promise.all([
        rc._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
        rc._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
    ]);
    return true;
}
/**
 * Ensures the last activated config are available to the getters.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 *
 * @returns A `Promise` that resolves when the last activated config is available to the getters.
 * @public
 */
function ensureInitialized(remoteConfig) {
    const rc = index_esm2017_getModularInstance(remoteConfig);
    if (!rc._initializePromise) {
        rc._initializePromise = rc._storageCache.loadFromStorage().then(() => {
            rc._isInitializationComplete = true;
        });
    }
    return rc._initializePromise;
}
/**
 * Fetches and caches configuration from the Remote Config service.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @public
 */
async function fetchConfig(remoteConfig) {
    const rc = index_esm2017_getModularInstance(remoteConfig);
    // Aborts the request after the given timeout, causing the fetch call to
    // reject with an `AbortError`.
    //
    // <p>Aborting after the request completes is a no-op, so we don't need a
    // corresponding `clearTimeout`.
    //
    // Locating abort logic here because:
    // * it uses a developer setting (timeout)
    // * it applies to all retries (like curl's max-time arg)
    // * it is consistent with the Fetch API's signal input
    const abortSignal = new RemoteConfigAbortSignal();
    setTimeout(async () => {
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        abortSignal.abort();
    }, rc.settings.fetchTimeoutMillis);
    // Catches *all* errors thrown by client so status can be set consistently.
    try {
        await rc._client.fetch({
            cacheMaxAgeMillis: rc.settings.minimumFetchIntervalMillis,
            signal: abortSignal
        });
        await rc._storageCache.setLastFetchStatus('success');
    }
    catch (e) {
        const lastFetchStatus = hasErrorCode(e, "fetch-throttle" /* ErrorCode.FETCH_THROTTLE */)
            ? 'throttle'
            : 'failure';
        await rc._storageCache.setLastFetchStatus(lastFetchStatus);
        throw e;
    }
}
/**
 * Gets all config.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @returns All config.
 *
 * @public
 */
function getAll(remoteConfig) {
    const rc = getModularInstance(remoteConfig);
    return getAllKeys(rc._storageCache.getActiveConfig(), rc.defaultConfig).reduce((allConfigs, key) => {
        allConfigs[key] = getValue(remoteConfig, key);
        return allConfigs;
    }, {});
}
/**
 * Gets the value for the given key as a boolean.
 *
 * Convenience method for calling <code>remoteConfig.getValue(key).asBoolean()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a boolean.
 * @public
 */
function getBoolean(remoteConfig, key) {
    return getValue(getModularInstance(remoteConfig), key).asBoolean();
}
/**
 * Gets the value for the given key as a number.
 *
 * Convenience method for calling <code>remoteConfig.getValue(key).asNumber()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a number.
 *
 * @public
 */
function getNumber(remoteConfig, key) {
    return getValue(getModularInstance(remoteConfig), key).asNumber();
}
/**
 * Gets the value for the given key as a string.
 * Convenience method for calling <code>remoteConfig.getValue(key).asString()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a string.
 *
 * @public
 */
function getString(remoteConfig, key) {
    return getValue(getModularInstance(remoteConfig), key).asString();
}
/**
 * Gets the {@link Value} for the given key.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key.
 *
 * @public
 */
function getValue(remoteConfig, key) {
    const rc = index_esm2017_getModularInstance(remoteConfig);
    if (!rc._isInitializationComplete) {
        rc._logger.debug(`A value was requested for key "${key}" before SDK initialization completed.` +
            ' Await on ensureInitialized if the intent was to get a previously activated value.');
    }
    const activeConfig = rc._storageCache.getActiveConfig();
    if (activeConfig && activeConfig[key] !== undefined) {
        return new Value('remote', activeConfig[key]);
    }
    else if (rc.defaultConfig && rc.defaultConfig[key] !== undefined) {
        return new Value('default', String(rc.defaultConfig[key]));
    }
    rc._logger.debug(`Returning static value for key "${key}".` +
        ' Define a default or remote value if this is unintentional.');
    return new Value('static');
}
/**
 * Defines the log level to use.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param logLevel - The log level to set.
 *
 * @public
 */
function esm_index_esm2017_setLogLevel(remoteConfig, logLevel) {
    const rc = getModularInstance(remoteConfig);
    switch (logLevel) {
        case 'debug':
            rc._logger.logLevel = LogLevel.DEBUG;
            break;
        case 'silent':
            rc._logger.logLevel = LogLevel.SILENT;
            break;
        default:
            rc._logger.logLevel = LogLevel.ERROR;
    }
}
/**
 * Dedupes and returns an array of all the keys of the received objects.
 */
function getAllKeys(obj1 = {}, obj2 = {}) {
    return Object.keys(Object.assign(Object.assign({}, obj1), obj2));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the {@link RemoteConfigClient} abstraction with success response caching.
 *
 * <p>Comparable to the browser's Cache API for responses, but the Cache API requires a Service
 * Worker, which requires HTTPS, which would significantly complicate SDK installation. Also, the
 * Cache API doesn't support matching entries by time.
 */
class CachingClient {
    constructor(client, storage, storageCache, logger) {
        this.client = client;
        this.storage = storage;
        this.storageCache = storageCache;
        this.logger = logger;
    }
    /**
     * Returns true if the age of the cached fetched configs is less than or equal to
     * {@link Settings#minimumFetchIntervalInSeconds}.
     *
     * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
     * native Fetch API.
     *
     * <p>Visible for testing.
     */
    isCachedDataFresh(cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
        // Cache can only be fresh if it's populated.
        if (!lastSuccessfulFetchTimestampMillis) {
            this.logger.debug('Config fetch cache check. Cache unpopulated.');
            return false;
        }
        // Calculates age of cache entry.
        const cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
        const isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
        this.logger.debug('Config fetch cache check.' +
            ` Cache age millis: ${cacheAgeMillis}.` +
            ` Cache max age millis (minimumFetchIntervalMillis setting): ${cacheMaxAgeMillis}.` +
            ` Is cache hit: ${isCachedDataFresh}.`);
        return isCachedDataFresh;
    }
    async fetch(request) {
        // Reads from persisted storage to avoid cache miss if callers don't wait on initialization.
        const [lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse] = await Promise.all([
            this.storage.getLastSuccessfulFetchTimestampMillis(),
            this.storage.getLastSuccessfulFetchResponse()
        ]);
        // Exits early on cache hit.
        if (lastSuccessfulFetchResponse &&
            this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) {
            return lastSuccessfulFetchResponse;
        }
        // Deviates from pure decorator by not honoring a passed ETag since we don't have a public API
        // that allows the caller to pass an ETag.
        request.eTag =
            lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
        // Falls back to service on cache miss.
        const response = await this.client.fetch(request);
        // Fetch throws for non-success responses, so success is guaranteed here.
        const storageOperations = [
            // Uses write-through cache for consistency with synchronous public API.
            this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
        ];
        if (response.status === 200) {
            // Caches response only if it has changed, ie non-304 responses.
            storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
        }
        await Promise.all(storageOperations);
        return response;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Attempts to get the most accurate browser language setting.
 *
 * <p>Adapted from getUserLanguage in packages/auth/src/utils.js for TypeScript.
 *
 * <p>Defers default language specification to server logic for consistency.
 *
 * @param navigatorLanguage Enables tests to override read-only {@link NavigatorLanguage}.
 */
function getUserLanguage(navigatorLanguage = navigator) {
    return (
    // Most reliable, but only supported in Chrome/Firefox.
    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
        // Supported in most browsers, but returns the language of the browser
        // UI, not the language set in browser settings.
        navigatorLanguage.language
    // Polyfill otherwise.
    );
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the Client abstraction for the Remote Config REST API.
 */
class RestClient {
    constructor(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
        this.firebaseInstallations = firebaseInstallations;
        this.sdkVersion = sdkVersion;
        this.namespace = namespace;
        this.projectId = projectId;
        this.apiKey = apiKey;
        this.appId = appId;
    }
    /**
     * Fetches from the Remote Config REST API.
     *
     * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
     * connect to the network.
     * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
     * fetch response.
     * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
     */
    async fetch(request) {
        const [installationId, installationToken] = await Promise.all([
            this.firebaseInstallations.getId(),
            this.firebaseInstallations.getToken()
        ]);
        const urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE ||
            'https://firebaseremoteconfig.googleapis.com';
        const url = `${urlBase}/v1/projects/${this.projectId}/namespaces/${this.namespace}:fetch?key=${this.apiKey}`;
        const headers = {
            'Content-Type': 'application/json',
            'Content-Encoding': 'gzip',
            // Deviates from pure decorator by not passing max-age header since we don't currently have
            // service behavior using that header.
            'If-None-Match': request.eTag || '*'
        };
        const requestBody = {
            /* eslint-disable camelcase */
            sdk_version: this.sdkVersion,
            app_instance_id: installationId,
            app_instance_id_token: installationToken,
            app_id: this.appId,
            language_code: getUserLanguage()
            /* eslint-enable camelcase */
        };
        const options = {
            method: 'POST',
            headers,
            body: JSON.stringify(requestBody)
        };
        // This logic isn't REST-specific, but shimming abort logic isn't worth another decorator.
        const fetchPromise = fetch(url, options);
        const timeoutPromise = new Promise((_resolve, reject) => {
            // Maps async event listener to Promise API.
            request.signal.addEventListener(() => {
                // Emulates https://heycam.github.io/webidl/#aborterror
                const error = new Error('The operation was aborted.');
                error.name = 'AbortError';
                reject(error);
            });
        });
        let response;
        try {
            await Promise.race([fetchPromise, timeoutPromise]);
            response = await fetchPromise;
        }
        catch (originalError) {
            let errorCode = "fetch-client-network" /* ErrorCode.FETCH_NETWORK */;
            if ((originalError === null || originalError === void 0 ? void 0 : originalError.name) === 'AbortError') {
                errorCode = "fetch-timeout" /* ErrorCode.FETCH_TIMEOUT */;
            }
            throw esm_index_esm2017_ERROR_FACTORY.create(errorCode, {
                originalErrorMessage: originalError === null || originalError === void 0 ? void 0 : originalError.message
            });
        }
        let status = response.status;
        // Normalizes nullable header to optional.
        const responseEtag = response.headers.get('ETag') || undefined;
        let config;
        let state;
        // JSON parsing throws SyntaxError if the response body isn't a JSON string.
        // Requesting application/json and checking for a 200 ensures there's JSON data.
        if (response.status === 200) {
            let responseBody;
            try {
                responseBody = await response.json();
            }
            catch (originalError) {
                throw esm_index_esm2017_ERROR_FACTORY.create("fetch-client-parse" /* ErrorCode.FETCH_PARSE */, {
                    originalErrorMessage: originalError === null || originalError === void 0 ? void 0 : originalError.message
                });
            }
            config = responseBody['entries'];
            state = responseBody['state'];
        }
        // Normalizes based on legacy state.
        if (state === 'INSTANCE_STATE_UNSPECIFIED') {
            status = 500;
        }
        else if (state === 'NO_CHANGE') {
            status = 304;
        }
        else if (state === 'NO_TEMPLATE' || state === 'EMPTY_CONFIG') {
            // These cases can be fixed remotely, so normalize to safe value.
            config = {};
        }
        // Normalize to exception-based control flow for non-success cases.
        // Encapsulates HTTP specifics in this class as much as possible. Status is still the best for
        // differentiating success states (200 from 304; the state body param is undefined in a
        // standard 304).
        if (status !== 304 && status !== 200) {
            throw esm_index_esm2017_ERROR_FACTORY.create("fetch-status" /* ErrorCode.FETCH_STATUS */, {
                httpStatus: status
            });
        }
        return { status, eTag: responseEtag, config };
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */
function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject) => {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(() => {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(esm_index_esm2017_ERROR_FACTORY.create("fetch-throttle" /* ErrorCode.FETCH_THROTTLE */, {
                throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */
function isRetriableError(e) {
    if (!(e instanceof FirebaseError) || !e.customData) {
        return false;
    }
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return (httpStatus === 429 ||
        httpStatus === 500 ||
        httpStatus === 503 ||
        httpStatus === 504);
}
/**
 * Decorates a Client with retry logic.
 *
 * <p>Comparable to CachingClient, but uses backoff logic instead of cache max age and doesn't cache
 * responses (because the SDK has no use for error responses).
 */
class RetryingClient {
    constructor(client, storage) {
        this.client = client;
        this.storage = storage;
    }
    async fetch(request) {
        const throttleMetadata = (await this.storage.getThrottleMetadata()) || {
            backoffCount: 0,
            throttleEndTimeMillis: Date.now()
        };
        return this.attemptFetch(request, throttleMetadata);
    }
    /**
     * A recursive helper for attempting a fetch request repeatedly.
     *
     * @throws any non-retriable errors.
     */
    async attemptFetch(request, { throttleEndTimeMillis, backoffCount }) {
        // Starts with a (potentially zero) timeout to support resumption from stored state.
        // Ensures the throttle end time is honored if the last attempt timed out.
        // Note the SDK will never make a request if the fetch timeout expires at this point.
        await setAbortableTimeout(request.signal, throttleEndTimeMillis);
        try {
            const response = await this.client.fetch(request);
            // Note the SDK only clears throttle state if response is success or non-retriable.
            await this.storage.deleteThrottleMetadata();
            return response;
        }
        catch (e) {
            if (!isRetriableError(e)) {
                throw e;
            }
            // Increments backoff state.
            const throttleMetadata = {
                throttleEndTimeMillis: Date.now() + calculateBackoffMillis(backoffCount),
                backoffCount: backoffCount + 1
            };
            // Persists state.
            await this.storage.setThrottleMetadata(throttleMetadata);
            return this.attemptFetch(request, throttleMetadata);
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_FETCH_TIMEOUT_MILLIS = 60 * 1000; // One minute
const DEFAULT_CACHE_MAX_AGE_MILLIS = 12 * 60 * 60 * 1000; // Twelve hours.
/**
 * Encapsulates business logic mapping network and storage dependencies to the public SDK API.
 *
 * See {@link https://github.com/firebase/firebase-js-sdk/blob/main/packages/firebase/index.d.ts|interface documentation} for method descriptions.
 */
class RemoteConfig {
    constructor(
    // Required by FirebaseServiceFactory interface.
    app, 
    // JS doesn't support private yet
    // (https://github.com/tc39/proposal-class-fields#private-fields), so we hint using an
    // underscore prefix.
    /**
     * @internal
     */
    _client, 
    /**
     * @internal
     */
    _storageCache, 
    /**
     * @internal
     */
    _storage, 
    /**
     * @internal
     */
    _logger) {
        this.app = app;
        this._client = _client;
        this._storageCache = _storageCache;
        this._storage = _storage;
        this._logger = _logger;
        /**
         * Tracks completion of initialization promise.
         * @internal
         */
        this._isInitializationComplete = false;
        this.settings = {
            fetchTimeoutMillis: DEFAULT_FETCH_TIMEOUT_MILLIS,
            minimumFetchIntervalMillis: DEFAULT_CACHE_MAX_AGE_MILLIS
        };
        this.defaultConfig = {};
    }
    get fetchTimeMillis() {
        return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
    }
    get lastFetchStatus() {
        return this._storageCache.getLastFetchStatus() || 'no-fetch-yet';
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Converts an error event associated with a {@link IDBRequest} to a {@link FirebaseError}.
 */
function toFirebaseError(event, errorCode) {
    const originalError = event.target.error || undefined;
    return esm_index_esm2017_ERROR_FACTORY.create(errorCode, {
        originalErrorMessage: originalError && (originalError === null || originalError === void 0 ? void 0 : originalError.message)
    });
}
/**
 * A general-purpose store keyed by app + namespace + {@link
 * ProjectNamespaceKeyFieldValue}.
 *
 * <p>The Remote Config SDK can be used with multiple app installations, and each app can interact
 * with multiple namespaces, so this store uses app (ID + name) and namespace as common parent keys
 * for a set of key-value pairs. See {@link Storage#createCompositeKey}.
 *
 * <p>Visible for testing.
 */
const APP_NAMESPACE_STORE = 'app_namespace_store';
const index_esm2017_DB_NAME = 'firebase_remote_config';
const index_esm2017_DB_VERSION = 1;
// Visible for testing.
function openDatabase() {
    return new Promise((resolve, reject) => {
        try {
            const request = indexedDB.open(index_esm2017_DB_NAME, index_esm2017_DB_VERSION);
            request.onerror = event => {
                reject(toFirebaseError(event, "storage-open" /* ErrorCode.STORAGE_OPEN */));
            };
            request.onsuccess = event => {
                resolve(event.target.result);
            };
            request.onupgradeneeded = event => {
                const db = event.target.result;
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (event.oldVersion) {
                    case 0:
                        db.createObjectStore(APP_NAMESPACE_STORE, {
                            keyPath: 'compositeKey'
                        });
                }
            };
        }
        catch (error) {
            reject(esm_index_esm2017_ERROR_FACTORY.create("storage-open" /* ErrorCode.STORAGE_OPEN */, {
                originalErrorMessage: error === null || error === void 0 ? void 0 : error.message
            }));
        }
    });
}
/**
 * Abstracts data persistence.
 */
class Storage {
    /**
     * @param appId enables storage segmentation by app (ID + name).
     * @param appName enables storage segmentation by app (ID + name).
     * @param namespace enables storage segmentation by namespace.
     */
    constructor(appId, appName, namespace, openDbPromise = openDatabase()) {
        this.appId = appId;
        this.appName = appName;
        this.namespace = namespace;
        this.openDbPromise = openDbPromise;
    }
    getLastFetchStatus() {
        return this.get('last_fetch_status');
    }
    setLastFetchStatus(status) {
        return this.set('last_fetch_status', status);
    }
    // This is comparable to a cache entry timestamp. If we need to expire other data, we could
    // consider adding timestamp to all storage records and an optional max age arg to getters.
    getLastSuccessfulFetchTimestampMillis() {
        return this.get('last_successful_fetch_timestamp_millis');
    }
    setLastSuccessfulFetchTimestampMillis(timestamp) {
        return this.set('last_successful_fetch_timestamp_millis', timestamp);
    }
    getLastSuccessfulFetchResponse() {
        return this.get('last_successful_fetch_response');
    }
    setLastSuccessfulFetchResponse(response) {
        return this.set('last_successful_fetch_response', response);
    }
    getActiveConfig() {
        return this.get('active_config');
    }
    setActiveConfig(config) {
        return this.set('active_config', config);
    }
    getActiveConfigEtag() {
        return this.get('active_config_etag');
    }
    setActiveConfigEtag(etag) {
        return this.set('active_config_etag', etag);
    }
    getThrottleMetadata() {
        return this.get('throttle_metadata');
    }
    setThrottleMetadata(metadata) {
        return this.set('throttle_metadata', metadata);
    }
    deleteThrottleMetadata() {
        return this.delete('throttle_metadata');
    }
    async get(key) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readonly');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.get(compositeKey);
                request.onerror = event => {
                    reject(toFirebaseError(event, "storage-get" /* ErrorCode.STORAGE_GET */));
                };
                request.onsuccess = event => {
                    const result = event.target.result;
                    if (result) {
                        resolve(result.value);
                    }
                    else {
                        resolve(undefined);
                    }
                };
            }
            catch (e) {
                reject(esm_index_esm2017_ERROR_FACTORY.create("storage-get" /* ErrorCode.STORAGE_GET */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    async set(key, value) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.put({
                    compositeKey,
                    value
                });
                request.onerror = (event) => {
                    reject(toFirebaseError(event, "storage-set" /* ErrorCode.STORAGE_SET */));
                };
                request.onsuccess = () => {
                    resolve();
                };
            }
            catch (e) {
                reject(esm_index_esm2017_ERROR_FACTORY.create("storage-set" /* ErrorCode.STORAGE_SET */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    async delete(key) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.delete(compositeKey);
                request.onerror = (event) => {
                    reject(toFirebaseError(event, "storage-delete" /* ErrorCode.STORAGE_DELETE */));
                };
                request.onsuccess = () => {
                    resolve();
                };
            }
            catch (e) {
                reject(esm_index_esm2017_ERROR_FACTORY.create("storage-delete" /* ErrorCode.STORAGE_DELETE */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    // Facilitates composite key functionality (which is unsupported in IE).
    createCompositeKey(key) {
        return [this.appId, this.appName, this.namespace, key].join();
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A memory cache layer over storage to support the SDK's synchronous read requirements.
 */
class StorageCache {
    constructor(storage) {
        this.storage = storage;
    }
    /**
     * Memory-only getters
     */
    getLastFetchStatus() {
        return this.lastFetchStatus;
    }
    getLastSuccessfulFetchTimestampMillis() {
        return this.lastSuccessfulFetchTimestampMillis;
    }
    getActiveConfig() {
        return this.activeConfig;
    }
    /**
     * Read-ahead getter
     */
    async loadFromStorage() {
        const lastFetchStatusPromise = this.storage.getLastFetchStatus();
        const lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
        const activeConfigPromise = this.storage.getActiveConfig();
        // Note:
        // 1. we consistently check for undefined to avoid clobbering defined values
        //   in memory
        // 2. we defer awaiting to improve readability, as opposed to destructuring
        //   a Promise.all result, for example
        const lastFetchStatus = await lastFetchStatusPromise;
        if (lastFetchStatus) {
            this.lastFetchStatus = lastFetchStatus;
        }
        const lastSuccessfulFetchTimestampMillis = await lastSuccessfulFetchTimestampMillisPromise;
        if (lastSuccessfulFetchTimestampMillis) {
            this.lastSuccessfulFetchTimestampMillis =
                lastSuccessfulFetchTimestampMillis;
        }
        const activeConfig = await activeConfigPromise;
        if (activeConfig) {
            this.activeConfig = activeConfig;
        }
    }
    /**
     * Write-through setters
     */
    setLastFetchStatus(status) {
        this.lastFetchStatus = status;
        return this.storage.setLastFetchStatus(status);
    }
    setLastSuccessfulFetchTimestampMillis(timestampMillis) {
        this.lastSuccessfulFetchTimestampMillis = timestampMillis;
        return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
    }
    setActiveConfig(activeConfig) {
        this.activeConfig = activeConfig;
        return this.storage.setActiveConfig(activeConfig);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerRemoteConfig() {
    _registerComponent(new Component(RC_COMPONENT_NAME, remoteConfigFactory, "PUBLIC" /* ComponentType.PUBLIC */).setMultipleInstances(true));
    registerVersion(dist_esm_index_esm2017_name, esm_index_esm2017_version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    registerVersion(dist_esm_index_esm2017_name, esm_index_esm2017_version, 'esm2017');
    function remoteConfigFactory(container, { instanceIdentifier: namespace }) {
        /* Dependencies */
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        // The following call will always succeed because rc has `import '@firebase/installations'`
        const installations = container
            .getProvider('installations-internal')
            .getImmediate();
        // Guards against the SDK being used in non-browser environments.
        if (typeof window === 'undefined') {
            throw esm_index_esm2017_ERROR_FACTORY.create("registration-window" /* ErrorCode.REGISTRATION_WINDOW */);
        }
        // Guards against the SDK being used when indexedDB is not available.
        if (!index_esm2017_isIndexedDBAvailable()) {
            throw esm_index_esm2017_ERROR_FACTORY.create("indexed-db-unavailable" /* ErrorCode.INDEXED_DB_UNAVAILABLE */);
        }
        // Normalizes optional inputs.
        const { projectId, apiKey, appId } = app.options;
        if (!projectId) {
            throw esm_index_esm2017_ERROR_FACTORY.create("registration-project-id" /* ErrorCode.REGISTRATION_PROJECT_ID */);
        }
        if (!apiKey) {
            throw esm_index_esm2017_ERROR_FACTORY.create("registration-api-key" /* ErrorCode.REGISTRATION_API_KEY */);
        }
        if (!appId) {
            throw esm_index_esm2017_ERROR_FACTORY.create("registration-app-id" /* ErrorCode.REGISTRATION_APP_ID */);
        }
        namespace = namespace || 'firebase';
        const storage = new Storage(appId, app.name, namespace);
        const storageCache = new StorageCache(storage);
        const logger = new Logger(dist_esm_index_esm2017_name);
        // Sets ERROR as the default log level.
        // See RemoteConfig#setLogLevel for corresponding normalization to ERROR log level.
        logger.logLevel = index_esm2017_LogLevel.ERROR;
        const restClient = new RestClient(installations, 
        // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
        SDK_VERSION, namespace, projectId, apiKey, appId);
        const retryingClient = new RetryingClient(restClient, storage);
        const cachingClient = new CachingClient(retryingClient, storage, storageCache, logger);
        const remoteConfigInstance = new RemoteConfig(app, cachingClient, storageCache, storage, logger);
        // Starts warming cache.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        ensureInitialized(remoteConfigInstance);
        return remoteConfigInstance;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// This API is put in a separate file, so we can stub fetchConfig and activate in tests.
// It's not possible to stub standalone functions from the same module.
/**
 *
 * Performs fetch and activate operations, as a convenience.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 *
 * @returns A `Promise` which resolves to true if the current call activated the fetched configs.
 * If the fetched configs were already activated, the `Promise` will resolve to false.
 *
 * @public
 */
async function fetchAndActivate(remoteConfig) {
    remoteConfig = index_esm2017_getModularInstance(remoteConfig);
    await fetchConfig(remoteConfig);
    return activate(remoteConfig);
}
/**
 * This method provides two different checks:
 *
 * 1. Check if IndexedDB exists in the browser environment.
 * 2. Check if the current browser context allows IndexedDB `open()` calls.
 *
 * @returns A `Promise` which resolves to true if a {@link RemoteConfig} instance
 * can be initialized in this environment, or false if it cannot.
 * @public
 */
async function isSupported() {
    if (!isIndexedDBAvailable()) {
        return false;
    }
    try {
        const isDBOpenable = await validateIndexedDBOpenable();
        return isDBOpenable;
    }
    catch (error) {
        return false;
    }
}

/**
 * The Firebase Remote Config Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
/** register component and version */
registerRemoteConfig();


//# sourceMappingURL=index.esm2017.js.map

;// ./node_modules/firebase/remote-config/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map

;// ./components/eui-maintenance/eui-maintenance-styles.ts

const euiMaintenanceStyles = (0,lit/* css */.AH) `
    .eui-maintenance {
        position: fixed;
        z-index: 2010;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: var(--eui-color-grey-100);
    }
    .eui-maintenance.eui-maintenance--apc {
        background-color: var(--eui-color-grey-50);
    }
    .eui-maintenance-content.eui-panel {
        min-width: 850px;
        min-height: 600px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .eui-maintenance.eui-maintenance--apc .eui-maintenance-content.eui-panel {
        border-radius: 0;
        min-width: 507px;
        box-shadow: none;
    }
    .eui-maintenance__tip {
        display: block;
        background-image: url('https://cdn.eurofirms.com/assets/tips-errors-screen/maintenance-tip.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        height: 300px;
        width: 100%;
        margin-bottom: 35px;
        max-width: 400px;
        margin: auto;
    }
    .eui-maintenance.eui-maintenance--apc .eui-maintenance__tip {
        background-image: url('https://cdn.eurofirms.com/assets/tips-errors-screen/maintenance-tip-theme-apc.svg');
        max-width: 140px;
        height: 150px;
    }
    .eui-maintenance__title { }
    .eui-maintenance__message { }
    .eui-maintenance.eui-maintenance--apc .eui-maintenance__message { 
        max-width: 320px;
        margin: 0 auto;
    }
    .eui-maintenance-logo-link {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .eui-maintenance.eui-maintenance--apc .eui-maintenance-logo-link {
        width: 127px;
        height: 38px;
        margin: 0 auto 50px;
    }
    @media only screen and (max-width: 992px) {
        .eui-maintenance-content {
            min-width: 100%;
            min-height: calc(100% - 85px);
            border-radius: unset;
        }
        .eui-maintenance-logo-link {
            height: 85px;
        }
    }
`;

// EXTERNAL MODULE: ./components/shared/eui-buttons.ts
var eui_buttons = __webpack_require__(1835);
;// ./components/shared/eui-panel.ts

const euiPanelStyles = (0,lit/* css */.AH) `
    .eui-panel {
        background-color:#fff;
        box-shadow:0px 5px 16px rgba(50,132,229,.16);
        border-radius:16px;border:none;
    }
    .eui-panel__header{
        padding:20px;
        position:relative;
    }
    .eui-panel__header::after{
        content:"";
        position:absolute;
        bottom:0;
        left:20px;
        right:20px;
        border-bottom:1px solid #eee;
    }
    .eui-panel__body{
        padding:20px;
    }
    .eui-panel__footer{
        padding:20px;position:relative;
    }
    .eui-panel__footer::before{
        content:"";position:absolute;
        top:0;
        left:20px;
        right:20px;
        border-top:1px solid #eee;
    }
  }`;

// EXTERNAL MODULE: ./utils/translateService.ts + 11 modules
var translateService = __webpack_require__(2616);
// EXTERNAL MODULE: ./components/shared/eui-titles.ts
var eui_titles = __webpack_require__(9203);
// EXTERNAL MODULE: ./components/shared/eui-utils.ts
var eui_utils = __webpack_require__(3251);
// EXTERNAL MODULE: ./components/shared/eui-colors.ts
var eui_colors = __webpack_require__(9084);
// EXTERNAL MODULE: ./components/shared/eui-texts.ts
var eui_texts = __webpack_require__(1754);
;// ./components/shared/eui-logo.ts

const euiLogoStyles = (0,lit/* css */.AH) `
    .eui-logo {
        display: block;
        height: 50px;
        width: 175px;
        background-size: contain;
        background-position: 50%;
        background-repeat: no-repeat;
    }
    .eui-logo--ett {
        background-image: url("https://cdn.eurofirms.com/assets/icons/logo_menu.svg");
    }
    .eui-logo--people-first {
        background-image: url("https://cdn.eurofirms.com/assets/icons/logo_people-first.svg");
    }
`;

// EXTERNAL MODULE: ./utils/cultureHelper.ts
var cultureHelper = __webpack_require__(2777);
;// ./components/eui-maintenance/eui-maintenance.ts
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














let EuiCookieAcceptanceManager = class EuiCookieAcceptanceManager extends lit/* LitElement */.WF {
    constructor() {
        super();
        this.firebaseConfig = {
            apiKey: 'AIzaSyAPXXNwRqv7sjGocB9Bf3i5QNx83rRCcCw',
            authDomain: 'eurofirms-app.firebaseapp.com',
            databaseURL: 'https://eurofirms-app.firebaseio.com',
            projectId: 'eurofirms-app',
            storageBucket: 'eurofirms-app.appspot.com',
            messagingSenderId: '1000972846040'
        };
        this._translateService = new translateService/* TranslateService */.c();
    }
    static get styles() {
        return [
            eui_buttons/* euiButtonStyles */.U,
            eui_titles/* euiTitleStyles */.K,
            eui_texts/* euiTextStyles */.H,
            eui_colors/* euiColorStyles */.$,
            eui_utils/* euiUtilsStyles */.H,
            euiPanelStyles,
            euiLogoStyles,
            euiMaintenanceStyles
        ];
    }
    render() {
        if (this.maintenanceUp)
            return (0,lit/* html */.qy) `
        <div
          class="eui-maintenance eui-font-family-f1 ${this._getMaintenanceThemeClass()}"
        >
          ${this._getMaintenanceThemeBody()}
        </div>
      `;
    }
    firstUpdated(changedProperties) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.culture)
                throw Error('culture can not been undefined or null');
            this._translateService.setLanguage(cultureHelper/* cultureHelper */.F.getLangFromCulture(this.culture));
            if (!this.forceMaintenance) {
                if (!this.appId)
                    throw Error('appId can not been undefined or null');
                else
                    this.firebaseConfig['appId'] = this.appId;
                if (this.measurementId)
                    this.firebaseConfig['measurementId'] = this.measurementId;
                this._app = !getApps().length ? initializeApp(this.firebaseConfig) : index_esm2017_getApp();
                this.getInstance();
                this.setMinimumFetchTime();
                this.setDefaultValues();
                this.maintenanceUp = yield this.getMaintenanceValue();
            }
            else {
                this.maintenanceUp = true;
                this.showMaintenance();
            }
        });
    }
    showMaintenance() {
        if (this.maintenanceUp) {
            const _body = document.getElementsByTagName('body')[0];
            _body.style['overflow'] = 'hidden';
        }
    }
    getInstance() {
        const remoteConfig = getRemoteConfig(this._app);
    }
    setMinimumFetchTime() {
        const remoteConfig = getRemoteConfig(this._app);
        remoteConfig.settings.minimumFetchIntervalMillis = 0;
    }
    setDefaultValues() {
        if (!this.appKey)
            throw Error('appkey can not been undefined or null');
        const remoteConfig = getRemoteConfig(this._app);
        remoteConfig.defaultConfig[this.appKey] = false;
    }
    getMaintenanceValue() {
        const remoteConfig = getRemoteConfig(this._app);
        return fetchAndActivate(remoteConfig)
            .then(() => {
            const value = getValue(remoteConfig, this.appKey);
            return value.asBoolean();
        })
            .catch((err) => {
            return false;
        });
    }
    _getMaintenanceThemeClass() {
        if (this.theme === 'apc')
            return 'eui-maintenance--apc';
        return '';
    }
    _getMaintenanceThemeBody() {
        switch (this.theme) {
            case 'apc':
                return this._getApcThemeBody();
            default:
                return this._getDefaultThemeBody();
        }
    }
    _getDefaultThemeBody() {
        return (0,lit/* html */.qy) `
      ${!this.hiddenLogo ? this._getLogoBrandTemplate() : ''}

      <div class="eui-maintenance-content eui-panel ${this.hiddenLogo ? 'eui-mt-4' : ''}">
        <div class="eui-panel__body eui-text-center">
          <i class="eui-maintenance__tip"></i>

          <h1 class="eui-maintenance__title eui-title-type4 eui-color-secondary">
            ${this._translateService.getLiteral('MAINTENANCE.TITLE')}
          </h1>

          <p class="eui-maintenance__message eui-text-type1">
            ${this._translateService.getLiteral('MAINTENANCE.MESSAGE')}
          </p>
        </div>
      </div>
    `;
    }
    _getApcThemeBody() {
        return (0,lit/* html */.qy) `
      <div class="eui-maintenance-content eui-panel eui-mt-11">
        ${!this.hiddenLogo ? this._getLogoBrandTemplate() : ''}

        <div class="eui-panel__body eui-text-center">
          <i class="eui-maintenance__tip"></i>

          <h1 class="eui-maintenance__title eui-title-type4 eui-color-secondary eui-mt-6">
            ${this._translateService.getLiteral('MAINTENANCE.THEME.APC.TITLE')}
          </h1>

          <p class="eui-maintenance__message eui-text-type1">
            ${this._translateService.getLiteral('MAINTENANCE.THEME.APC.MESSAGE')}
          </p>
        </div>
      </div>
    `;
    }
    _getLogoBrandTemplate() {
        return (0,lit/* html */.qy) ` <a
      class="eui-maintenance-logo-link"
      href="https://www.eurofirms.com/${cultureHelper/* cultureHelper */.F.generateUrlCulture(this.culture)}/"
    >
      <span class="eui-logo eui-logo--people-first"></span>
    </a>`;
    }
};
__decorate([
    (0,decorators/* state */.wk)(),
    __metadata("design:type", Boolean)
], EuiCookieAcceptanceManager.prototype, "maintenanceUp", void 0);
__decorate([
    (0,decorators/* property */.MZ)(),
    __metadata("design:type", String)
], EuiCookieAcceptanceManager.prototype, "appKey", void 0);
__decorate([
    (0,decorators/* property */.MZ)(),
    __metadata("design:type", String)
], EuiCookieAcceptanceManager.prototype, "appId", void 0);
__decorate([
    (0,decorators/* property */.MZ)(),
    __metadata("design:type", String)
], EuiCookieAcceptanceManager.prototype, "measurementId", void 0);
__decorate([
    (0,decorators/* property */.MZ)(),
    __metadata("design:type", String)
], EuiCookieAcceptanceManager.prototype, "culture", void 0);
__decorate([
    (0,decorators/* property */.MZ)({ type: Boolean }),
    __metadata("design:type", Boolean)
], EuiCookieAcceptanceManager.prototype, "hiddenLogo", void 0);
__decorate([
    (0,decorators/* property */.MZ)({ type: Boolean }),
    __metadata("design:type", Boolean)
], EuiCookieAcceptanceManager.prototype, "forceMaintenance", void 0);
__decorate([
    (0,decorators/* property */.MZ)(),
    __metadata("design:type", String)
], EuiCookieAcceptanceManager.prototype, "theme", void 0);
EuiCookieAcceptanceManager = __decorate([
    (0,decorators/* customElement */.EM)('eui-maintenance'),
    __metadata("design:paramtypes", [])
], EuiCookieAcceptanceManager);


/******/ })()
;
//# sourceMappingURL=euiMaintenance.js.map